import type { Translations } from './types';

const it: Translations = {
  nav: {
    approvals: 'Approvazioni',
    home: 'Home',
    search: 'Cerca',
    dashboard: 'Dashboard',
    outdoors: 'Spazi Esterni',
    campaigns: 'Campagne',
    admin: 'Admin',
    logIn: 'Accedi',
    signUp: 'Registrati',
    logOut: 'Esci',
    account: 'Account',
    setupBusiness: "Configura l'Azienda",
    searchOutdoors: 'Cerca Spazi Esterni',
    manageOutdoors: 'Gestisci Spazi Esterni',
    verifyOutdoors: 'Verifica Spazi Esterni',
    adminPanel: 'Pannello di Amministrazione',
    upcomingCampaigns: 'Campagne Imminenti',
    getPaid: 'Ricevere Pagamento',
    revenue: 'Ricavi',
    payments: 'Pagamenti',
  },
  common: {
    save: 'Salva',
    cancel: 'Annulla',
    back: 'Indietro',
    next: 'Avanti',
    done: 'Fatto',
    loading: 'Caricamento…',
    error: 'Qualcosa è andato storto',
    confirm: 'Conferma',
    delete: 'Elimina',
    clear: 'Cancella',
    edit: 'Modifica',
    add: 'Aggiungi',
    search: 'Cerca',
    view: 'Visualizza',
    create: 'Crea',
    update: 'Aggiorna',
    submit: 'Invia',
    yes: 'Sì',
    no: 'No',
    close: 'Chiudi',
    upload: 'Carica',
    uploading: 'Caricamento…',
    saving: 'Salvataggio…',
    creating: 'Creazione…',
    noResults: 'Nessun risultato',
    required: 'Obbligatorio',
    optional: 'Opzionale',
    copy: 'Copia',
    copied: 'Copiato!',
    approve: 'Approva',
    reject: 'Rifiuta',
    page: 'Pagina',
    of: 'di',
    perDay: '/giorno',
    days: '{{count}} giorno',
    days_plural: '{{count}} giorni',
    termsAndConditions: 'Termini e Condizioni',
    selectCountry: 'Seleziona un paese...',
    noCountriesFound: 'Nessun paese trovato',
    notSet: 'Non impostato',
    showPassword: 'Mostra password',
    hidePassword: 'Nascondi password',
    refresh: 'Aggiorna',
    new: 'Nuovo',
    rowsPerPage: 'Righe per pagina',
  },
  home: {
    tagline: 'Il tuo marketplace OOH orientato alla visibilità',
    heroTitle: 'Il tuo brand verso nuove vette',
    heroSubtitle:
      'Scapow connette i proprietari di cartelloni con gli inserzionisti. Esplora spazi reali, pianifica campagne e raggiungi il tuo pubblico - tutto in un unico posto.',
    browseOutdoors: 'Esplora Spazi Esterni',
    getStartedFree: 'Inizia Gratuitamente',
    featuredOutdoors: 'Spazi in Evidenza',
    viewAll: 'Vedi tutti →',
    howItWorksTitle: 'Come funziona',
    howItWorksSubtitle: 'Tre semplici passi per portare il tuo messaggio al pubblico giusto.',
    step1Title: 'Trova lo spazio perfetto',
    step1Desc:
      'Cerca cartelloni per posizione, dimensione e prezzo. Filtra per disponibilità nelle tue date.',
    step2Title: 'Crea la tua campagna',
    step2Desc:
      'Aggiungi più spazi a una campagna, carica i tuoi creativi e ottieni i dettagli di pagamento.',
    step3Title: 'Monitora i risultati',
    step3Desc:
      'Tieni traccia del progresso della campagna, dello stato dei banner e delle metriche di performance dalla dashboard.',
    builtTitle: 'Costruito per entrambe le parti',
    builtSubtitle:
      'Che tu possieda cartelloni o voglia fare pubblicità, Scapow ti copre.',
    feature1Title: 'Elenca i tuoi spazi',
    feature1Desc:
      'Pubblica facilmente i tuoi cartelloni, imposta i prezzi, aggiungi foto e controlla la disponibilità.',
    feature2Title: 'Ricerca sulla mappa',
    feature2Desc:
      'Trova cartelloni su una mappa in tempo reale. Ingrandisci per raggio minore, riduci per maggiore copertura.',
    feature3Title: 'Gestione delle campagne',
    feature3Desc:
      'Crea campagne con più spazi, carica i creativi e paga tramite bonifico bancario.',
    feature4Title: 'Aziende verificate',
    feature4Desc: 'Tutte le aziende sono verificate con documenti aziendali prima di andare live.',
    feature5Title: 'Monitoraggio delle performance',
    feature5Desc:
      'Inserzionisti e fornitori ottengono panoramiche della dashboard su guadagni e attività.',
    feature6Title: 'Prezzi trasparenti',
    feature6Desc: 'Tariffe del fornitore mostrate al giorno - sempre visibili prima di confermare.',
    ctaTitle: 'Pronto per iniziare?',
    ctaSubtitle: 'Unisciti a Scapow oggi e inizia a connetterti con il mercato della pubblicità esterna.',
    createAccount: 'Crea Account',
    browseFirst: 'Esplora Prima',
    nearbyOutdoors: 'Spazi Vicino a Te',
    detectingLocation: 'Rilevamento della posizione…',
    basedOnLocation: 'Basato sulla tua posizione attuale',
    welcomeBack: 'Benvenuto, {{name}}',
    fromCompany: 'da {{company}}',
    ppPrompt: 'Tutti i tuoi outdoor sono pronti per nuove Campagne?',
    advertiserPrompt: 'Sei pronto a creare alcune Campagne?',
    noCompanyPrompt: 'Configura la tua azienda per sbloccare tutte le funzionalità.',
    goToDashboard: 'Vai alla Dashboard',
    inviteFrom: '{{company}} ti ha invitato a unirti al suo team su Scapow.',
    inviteFromDesc: 'Accetta per iniziare a collaborare su campagne pubblicitarie esterne.',
    inviteAccept: 'Accetta Invito',
    inviteDecline: 'Declina',
    inviteAccepted: 'Benvenuto/a! Ti sei unito con successo a {{company}}.',
    inviteDeclined: "Hai declinato l'invito.",
    ppHowItWorksSubtitle: 'Tutto ciò di cui hai bisogno per trasformare i tuoi spazi outdoor in una fonte di reddito costante.',
    ppStep1Title: 'Valorizza i tuoi spazi',
    ppStep1Desc: 'Inserisci i tuoi spazi outdoor con foto accattivanti, dimensioni precise e prezzi competitivi - così gli inserzionisti ne vedono subito il valore.',
    ppStep2Title: 'Fatti scoprire dai brand',
    ppStep2Desc: 'I tuoi spazi appaiono nelle ricerche degli inserzionisti che pianificano la prossima campagna. La campagna giusta ti trova.',
    ppStep3Title: 'Dimostralo e incassa',
    ppStep3Desc: 'Carica le prove fotografiche non appena il tuo spazio è installato e attivo. Il pagamento viene elaborato automaticamente dopo l\'approvazione.',
  },
  auth: {
    login: {
      heroTitle: 'Connetti il tuo brand con il mondo. Una nuova altezza alla volta.',
      heroSubtitle:
        "La piattaforma che collega i proprietari di cartelloni con gli inserzionisti - semplice, veloce e d'impatto.",
      title: 'Bentornato',
      subtitle: 'Accedi al tuo account per continuare',
      email: 'Indirizzo e-mail',
      password: 'Password',
      forgotPassword: 'Password dimenticata?',
      resendVerification: 'Reinvia email di verifica',
      signIn: 'Accedi',
      noAccount: 'Non hai un account?',
      createOne: 'Creane uno',
      invalidCredentials: 'E-mail o password non valide. Riprova.',
    },
    register: {
      heroTitle: 'Unisciti alla rivoluzione della pubblicità esterna',
      heroSubtitle:
        'Che tu possieda cartelloni o voglia fare pubblicità, Scapow lo rende semplice.',
      title: 'Crea il tuo account',
      subtitle: 'Inizia a gestire campagne di pubblicità esterna oggi',
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'Indirizzo e-mail',
      password: 'Password',
      confirmPassword: 'Conferma password',
      passwordHint: 'Minimo 8 caratteri',
      createAccount: 'Crea account',
      alreadyHaveAccount: 'Hai già un account?',
      signIn: 'Accedi',
      checkEmail: 'Controlla la tua e-mail',
      checkEmailDesc:
        "Abbiamo inviato un link di verifica al tuo indirizzo e-mail. Clicca su di esso per attivare il tuo account.",
      goToLogin: 'Vai al login',
      termsAgreement: 'Ho letto e accetto i',
      termsLink: 'Termini e Condizioni',
    },
    forgotPassword: {
      title: 'Reimposta la password',
      subtitle: "Inserisci la tua e-mail e ti invieremo un link per reimpostare la password",
      email: 'Indirizzo e-mail',
      sendReset: 'Invia link di reimpostazione',
      backToLogin: 'Torna al login',
      checkEmail: 'Controlla la tua e-mail',
      checkEmailDesc:
        "Se quell'indirizzo è registrato, riceverai presto un link di reimpostazione.",
    },
    resetPassword: {
      title: 'Imposta nuova password',
      subtitle: 'Scegli una password sicura che ricorderai.',
      newPassword: 'Nuova password',
      confirmPassword: 'Conferma password',
      save: 'Salva nuova password',
      submit: 'Aggiorna password',
    },
    verifyEmail: {
      verifying: 'Verifica della tua e-mail…',
      success: 'E-mail verificata!',
      successDesc: 'Il tuo account è ora attivo. Puoi accedere.',
      error: 'Verifica non riuscita',
      errorDesc: 'Il link potrebbe essere scaduto o non valido. Registrati di nuovo.',
      goToLogin: 'Vai al login',
      successDescBusiness: 'Il tuo account è ora attivo. Puoi accedere e configurare la tua azienda.',
      returnToLogin: 'Torna al login',
      resendButton: 'Richiedi nuovo link di verifica',
    },
    resendVerification: {
      title: 'Reinvia email di verifica',
      subtitle: "Inserisci la tua email e ti invieremo un nuovo link di verifica.",
      email: 'Indirizzo e-mail',
      send: 'Invia email di verifica',
      backToLogin: 'Torna al login',
      checkEmail: 'Controlla la tua email',
      checkEmailDesc: "Se il tuo account è in attesa di verifica, ti abbiamo inviato un nuovo link nella tua casella di posta.",
    },
  },
  business: {
    pendingVerification: 'Il suo account aziendale è attualmente in fase di validazione. Una volta completata la verifica da parte del nostro team, avrà accesso completo a tutte le funzionalità di Scapow. Nel frattempo, tenga d\'occhio la sua casella di posta - potremmo contattarla nel caso in cui fossero necessari ulteriori documenti.',
    setup: {
      title: "Configura la tua Azienda",
      subtitle: "Collega il tuo account a un'entità aziendale per iniziare a usare Scapow.",
      ppTitle: 'Fornitore di Spazi',
      ppDesc: 'Possiedo spazi pubblicitari esterni e voglio affittarli.',
      advertiserTitle: 'Inserzionista',
      advertiserDesc: 'Voglio prenotare campagne di pubblicità esterna.',
      changeType: 'Cambia ↩',
      createCompany: 'Crea nuova azienda',
      createCompanyDesc: 'Registra la tua azienda su Scapow.',
      joinCompany: 'Unisciti a un\'azienda esistente',
      joinCompanyDesc: 'Richiedi accesso a un\'azienda già registrata.',
      registerTitle: 'Registra la tua azienda',
      companyName: "Nome dell'azienda",
      vatNumber: 'Numero di Partita IVA',
      companyEmail: "E-mail aziendale",
      currency: 'Valuta preferita',
      currencyHint: 'Codice ISO valuta, es. EUR, USD, GBP',
      country: 'Paese',
      proofDocument: 'Documento di prova aziendale',
      proofHint: 'PDF, JPG o PNG',
      uploadProof: 'Clicca per caricare la prova aziendale',
      createCompanyBtn: 'Crea azienda',
      bankTitle: 'Dati bancari',
      bankSubtitlePP: 'Il tuo IBAN e SWIFT/BIC saranno utilizzati per i pagamenti quando le tue campagne pubblicitarie esterne saranno attive.',
      bankSubtitleAdvertiser: 'Il tuo IBAN e SWIFT/BIC saranno utilizzati per elaborare i rimborsi, ove applicabile.',
      findTitle: 'Trova la tua azienda',
      searchPlaceholder: "Cerca per nome dell'azienda…",
      noCompanies: 'Nessuna azienda trovata. Cerca per nome.',
      requestAccess: 'Richiedi accesso',
      requested: 'Richiesto',
      accessSentMsg:
        "Richiesta di accesso inviata! Un amministratore dell'azienda deve approvarla. Sarai notificato quando approvato.",
      pendingTitle: 'Richiesta di accesso in sospeso',
      pendingDesc: 'La tua richiesta di unirti a {{name}} è in fase di revisione. Sarai notificato quando approvata.',
      cancelRequest: 'Annulla richiesta',
      requestCancelled: 'Richiesta di accesso annullata.',
      connectingToEntity: 'Connessione alla tua organizzazione…',
      accessApproved: "La tua richiesta di accesso è stata approvata! Ora fai parte del team.",
      accessRejected: 'La tua richiesta di accesso è stata rifiutata. Per favore crea o unisciti a un\'altra entità aziendale.',
      orSetupYourOwn: 'Oppure registra la tua azienda o unisciti a una esistente di seguito.',
      invitationsTitle: 'Inviti in sospeso',
      invitationsSubtitle: "Sei stato invitato a unirti a un'azienda. Accetta o rifiuta qui sotto.",
      invitedOn: 'Invitato il',
      acceptInvitation: 'Accetta',
      declineInvitation: 'Rifiuta',
      invitationAccepted: 'Invito accettato! Connessione alla tua organizzazione…',
      invitationDeclined: 'Invito rifiutato.',
    },
    details: {
      title: 'Dettagli Azienda',
      subtitle: "Gestisci la registrazione e le informazioni bancarie della tua azienda.",
      registrationTitle: 'Dati di registrazione',
      companyName: "Nome dell'azienda",
      vatNumber: 'Partita IVA',
      companyEmail: 'E-mail aziendale',
      currency: 'Valuta preferita',
      country: 'Paese',
      portugueseRegion: 'Regione portoghese',
      regionContinent: 'Continente',
      regionAzores: 'Azzorre',
      regionMadeira: 'Madeira',
      replaceProof: 'Sostituisci documento di prova',
      uploadProof: 'Clicca per caricare un nuovo documento di prova',
      saveChanges: 'Salva modifiche',
      addressSectionTitle: 'Indirizzo',
      addressLine: 'Indirizzo',
      addressLinePlaceholder: 'Via Roma 123',
      city: 'Città',
      postCode: 'Codice postale',
      state: 'Stato',
      stateHint: 'Obbligatorio per i conti di pagamento in USD',
      selectState: 'Seleziona uno stato',
      bankTitle: 'Dati bancari',
      bankSubtitle: 'Utilizzato per ricevere pagamenti dagli inserzionisti.',
      bankSubtitlePP: 'Il tuo IBAN e SWIFT/BIC vengono utilizzati per i pagamenti quando le campagne sono attive.',
      bankSubtitleAdvertiser: 'Il tuo IBAN e SWIFT/BIC vengono utilizzati per i rimborsi, ove applicabile.',
      bankClickUnlock: 'Bloccato - clicca per modificare',
      iban: 'IBAN',
      swift: 'SWIFT / BIC',
      ibanHint: 'Numero di Conto Bancario Internazionale...',
      swiftHint: '8 o 11 caratteri: codice banca (4) + paese (2) + posizione (2) + filiale opzionale (3)',
      accountNumber: 'Numero di conto',
      accountNumberHint: 'Il tuo numero di conto bancario USD (4–17 cifre)',
      saveBankDetails: 'Salva dati bancari',
      verifiedLocked: "Il nome dell'azienda, il numero di partita IVA e il paese sono bloccati dopo la verifica.",
      verifiedBadge: 'Verificato',
      pendingReviewTitle: 'In Attesa di Approvazione',
      pendingReviewDesc: "La tua registrazione aziendale è in fase di revisione. Avrai accesso completo alla piattaforma non appena il nostro team la approverà - ti avviseremo in tempo reale.",
      verifiedTitle: 'Identità verificata',
      verifiedDesc: "L'identità della tua azienda è stata confermata. Non sono richiesti ulteriori documenti.",
      proofCardTitle: 'Documento di verifica',
      proofCardDesc: "Carica il documento di registrazione aziendale per supportare la verifica del tuo account. Il nostro team lo esaminerà e ti contatterà se necessario.",
      proofCardSubmit: 'Invia per revisione',
      proofCardSuccess: 'Documento inviato con successo. Il nostro team lo esaminerà e ti contatterà se necessario.',
      proofCardValidatingTitle: 'Documenti in fase di revisione',
      proofCardValidatingDesc: 'I tuoi documenti di verifica sono stati ricevuti e sono attualmente in fase di revisione da parte del nostro team. Ti avviseremo non appena il processo sarà completato.',
      proofCardProcessingTitle: 'Elaborazione file',
      proofCardProcessingDesc: 'Abbiamo ricevuto il tuo documento e lo stiamo verificando automaticamente. Non ci vorrà molto.',
      proofCardReplaceFile: 'Hai caricato il file sbagliato? Sostituiscilo',
    },
  },
  search: {
    instantBookingHint: 'Conferma immediata, senza attendere l’approvazione del fornitore',
    priceFilterLocked: 'I filtri di prezzo sono disponibili dopo aver effettuato l’accesso ed essere collegato a un’entità aziendale.',
    title: 'Cerca Spazi Esterni',
    subtitle: 'Trova spazi pubblicitari sulla mappa',
    filters: 'Filtri',
    minWidth: 'Larghezza min (m)',
    maxWidth: 'Larghezza max (m)',
    minHeight: 'Altezza min (m)',
    maxHeight: 'Altezza max (m)',
    minPrice: 'Prezzo min (€/giorno)',
    maxPrice: 'Prezzo max (€/giorno)',
    providerName: 'Nome fornitore',
    clearFilters: 'Cancella filtri',
    noResults: 'Nessuno spazio trovato in questa area',
    noResultsDesc: 'Prova ad ampliare l\'area sulla mappa, a perfezionare i filtri o ad estendere la durata della campagna per aumentare la disponibilità.',
    addToCart: 'Aggiungi al carrello',
    inCart: 'Nel carrello',
    selectDates: 'Seleziona date',
    from: 'Dal',
    to: 'Al',
    results: 'risultati',
    loading: 'Caricamento spazi…',
    resultsTab: 'Risultati ({{count}})',
    mapTab: 'Mappa',
    searching: 'Ricerca in corso…',
    found: '{{count}} spazio trovato',
    found_plural: '{{count}} spazi trovati',
    moveMap: 'Sposta la mappa per aggiornare i risultati',
    noticePeriodHint: 'Alcuni fornitori di spazi richiedono un periodo di preavviso minimo o un periodo minimo di noleggio prima che una campagna possa iniziare, il che può influire sulla disponibilità e sui risultati di ricerca.',
    noOutdoorsFound: 'Nessuno spazio pubblicitario trovato',
    noOutdoorsFoundAdjustDates: 'Prova a modificare le date di inizio e fine, oppure riduci lo zoom.',
    noOutdoorsFoundAdjustFilters: 'Riduci lo zoom o modifica i filtri.',
    inCampaign: 'In campagna',
    attributes: 'Situato vicino a',
    withDiscounts: 'Sconti volume disponibili',
    illuminated: 'Solo illuminati',
    illuminatedHint: 'lo spazio è illuminato (es. di notte)',
    containsDiscounts: 'Sconti volume',
    containsDiscountsDesc: 'Questo spazio offre prezzi a scaglioni - più giorni prenoti, più bassa è la tariffa giornaliera.',
  },
  outdoor: {
    startAtMonthFirstDay: 'Inizio il 1° del mese',
    startAtMonthFirstDayHint: 'Le prenotazioni devono iniziare il primo giorno di un mese. Con solo mesi interi, si prenotano per mesi di calendario interi (dal giorno 1 all’ultimo).',
    acceptingToastOn: '{{name}} ora accetta nuove campagne.',
    acceptingToastOff: '{{name}} è in pausa: nascosto dalla ricerca e chiuso a nuove prenotazioni.',
    acceptingToastBulkOn: '{{count}} spazio/i ora accettano nuove campagne.',
    acceptingToastBulkOff: '{{count}} spazio/i in pausa: nascosti dalla ricerca e chiusi a nuove prenotazioni.',
    fullMonthRequired: 'Solo mesi interi',
    fullMonthRequiredHint: 'Gli inserzionisti prenotano a mesi: dal giorno di inizio allo stesso giorno del mese successivo (iniziando il giorno 1, fino all’ultimo giorno del mese), per tutti i mesi consecutivi che desiderano.',
    fullMonthTooltip: 'Si prenota a mesi: dal giorno di inizio allo stesso giorno di un mese successivo.',
    stepsTitle: 'Configurazione dello spazio',
    stepNotSet: 'Non ancora impostato',
    stepLocationSet: 'Posizione impostata',
    stepNoticeSummary: 'Preavviso: {{count}} giorno/i',
    stepPhotosSummary: 'Foto: {{count}}',
    stepPhotosNone: 'Ancora nessuna foto',
    stepBlockedSummary: 'Periodi bloccati: {{count}}',
    stepOptional: 'Facoltativo',
    stepFeaturesSummary: 'Selezionate: {{count}}',
    fixHighlightedFields: 'Alcuni dati vanno corretti: abbiamo aperto il passaggio con il problema.',
    instantBooking: 'Prenotazione immediata',
    instantBookingTooltip: 'Prenotato subito, senza attendere la conferma del fornitore.',
    instantBookingHint: 'Gli inserzionisti prenotano questo spazio subito, senza attendere la tua approvazione. Lascia disattivato per esaminare prima ogni prenotazione.',
    kmAway: 'a {{distance}} km',
    productionCost: 'Costo di produzione',
    productionCostIncludes: 'include costi di stampa, allestimento, ecc.',
    priceHiddenTitle: 'Valori giornalieri riservati agli account aziendali',
    priceHiddenMessage: 'Accedi e assicurati di essere collegato a un’entità aziendale (fornitore di spazi o inserzionista) per vedere il valore giornaliero dello spazio.',
    manageTitle: 'Gestisci Spazi Esterni',
    addNew: 'Aggiungi Nuovo Spazio',
    noOutdoors: 'Nessuno spazio ancora',
    noOutdoorsDesc: 'Aggiungi il tuo primo spazio per iniziare a ricevere prenotazioni.',
    addFirst: 'Aggiungi il tuo primo spazio',
    editTitle: 'Modifica Spazio',
    createTitle: 'Aggiungi Nuovo Spazio',
    listSubtitle: 'Pubblica il tuo spazio su Scapow.',
    editSubtitle: 'Aggiorna i dettagli del tuo spazio.',
    location: 'Posizione',
    latitude: 'Latitudine',
    longitude: 'Longitudine',
    name: 'Nome',
    namePlaceholder: 'es: Corso Vittorio Emanuele – Cartellone A',
    description: 'Descrizione',
    descriptionPlaceholder: 'Cartellone premium su Corso Vittorio Emanuele, zona ad alto traffico…',
    dimensions: 'Dimensioni e Specifiche',
    width: 'Larghezza (m)',
    height: 'Altezza (m)',
    length: 'Lunghezza (m)',
    aspectRatio: 'Proporzioni del creativo',
    aspectRatioHint: 'Calcolato automaticamente da larghezza ÷ altezza',
    bleed: 'Margine al vivo (m)',
    bleedHint: 'Area di stampa oltre il bordo di taglio finale, che garantisce bordi puliti dopo il ritaglio.',
    illuminated: 'Illuminato',
    illuminatedHint: 'Questo spazio pubblicitario è illuminato, rimanendo visibile di notte.',
    currency: 'Valuta',
    currencyLockedHint: 'Impostata in base alla valuta del tuo account Fornitore.',
    pricing: 'Prezzi',
    excludeVat: 'IVA esclusa',
    vatIncluded: 'IVA inclusa',
    pricePerDay: 'Prezzo al giorno',
    volumeDiscounts: 'Sconti per volume',
    addDiscount: 'Aggiungi',
    daysArrow: 'giorni →',
    percentOff: '% sconto',
    photos: 'Foto della posizione',
    photosHint: 'Le foto vengono salvate automaticamente quando vengono caricate o rimosse.',
    uploadPhotos: 'Clicca per caricare foto della posizione',
    addMorePhotos: 'Aggiungi altre foto',
    currentPhotos: 'Foto attuali',
    uploadingPhotos: 'Caricamento foto...',
    photosUploaded: 'Foto caricate con successo',
    deletePhotoTitle: 'Eliminare la foto?',
    deletePhotoConfirm: 'Questa foto verrà rimossa definitivamente da questo outdoor.',
    filesSelected_one: '{{count}} file selezionato',
    filesSelected_other: '{{count}} file selezionati',
    blockedTimes: 'Periodi bloccati',
    blockedTimesDesc:
      'Blocca le date in cui lo spazio non è disponibile (manutenzione, pre-prenotazioni esterne, ecc.).',
    blockedTimesOverlapNote: 'I periodi non possono sovrapporsi tra loro né con prenotazioni di campagne attive.',
    blockFrom: 'Blocca dal',
    blockUntil: 'Blocca fino al',
    addBlockedTime: 'Aggiungi periodo bloccato',
    noBlockedTimes: 'Nessun periodo bloccato',
    occupiedByCampaign: 'Prenotato da una campagna',
    unsaved: 'Non salvato',
    unsavedChanges: '{{count}} modifica/modifiche non salvata/e - salva l\'outdoor per applicarle',
    selectBlockedDates: 'Seleziona una data di inizio e una data di fine.',
    legalDeclaration: "Dichiaro di avere diritti legali su questo spazio pubblicitario, di essere autorizzato a pubblicarlo commercialmente e che ciò è conforme a tutte le leggi, autorizzazioni e normative applicabili.",
    legalDeclarationRequired: 'Devi confermare di avere diritti legali su questo spazio prima di pubblicarlo.',
    createOutdoor: 'Crea spazio',
    saveChanges: 'Salva modifiche',
    deleteTitle: 'Elimina Spazio',
    deleteConfirm: 'Sei sicuro di voler eliminare questo spazio? Questa azione non può essere annullata.',
    hidden: 'Nascosto',
    visible: 'Visibile',
    viewDetails: 'Vedi dettagli',
    bookingRules: 'Regole di prenotazione',
    bookingRulesDesc: 'Definisci i requisiti di preavviso che gli inserzionisti devono rispettare prima della data di inizio della campagna.',
    minimumNoticeDays: 'Preavviso minimo (giorni)',
    minimumNoticeDaysHint: 'Le campagne devono essere completamente pagate e il creativo caricato almeno questo numero di giorni prima della data di inizio.',
    minimumDays: 'Durata minima del noleggio (giorni)',
    minimumDaysHint: 'Il numero minimo di giorni per cui gli inserzionisti devono noleggiare questo spazio.',
    acceptingCampaigns: 'Accetta nuove campagne',
    acceptingCampaignsOn: 'Questo outdoor è visibile nella ricerca e può essere aggiunto alle campagne.',
    acceptingCampaignsOff: 'Questo outdoor è nascosto dalla ricerca e non riceverà nuove prenotazioni.',
    acceptingBadge: 'Accetta campagne',
    notAcceptingBadge: 'Non accetta campagne',
    notAcceptingMsg: 'Questo outdoor non sta accettando nuove campagne al momento.',
    unavailableForDates: 'Questo outdoor non è disponibile per le date selezionate.',
    paused: 'In pausa',
    accepting: 'Accetta',
    availabilityToggleTooltip: 'Se questo outdoor è disponibile per le campagne o meno. Stato attuale: {{state}}',
    availabilityStateOn: 'Disponibile',
    availabilityStateOff: 'Non disponibile',
    toggleError: 'Impossibile aggiornare la visibilità della campagna.',
    bulkAccept: 'Abilita la ricezione di campagne per tutti gli outdoor in questa pagina',
    bulkPause: 'Sospendi la ricezione di campagne per tutti gli outdoor in questa pagina',
    commissionNote: 'Gli inserzionisti vedranno il prezzo di <bold>{{currency}} {{advertiserPrice}}/giorno</bold> - il tuo {{currency}} {{basePrice}} più una <bold>commissione Scapow del {{rate}}%</bold>.',
    advertiserPaysLabel: "L'inserzionista paga",
    advertiserPaysDesc: 'Include {{rate}}% di commissione Scapow',
    youReceiveLabel: '{{name}} riceve',
    youReceiveDesc: "Dopo {{rate}}% di commissione piattaforma (potrebbe applicarsi l'IVA sulla commissione)",
    searchByAddress: 'Cerca per indirizzo',
    dragPin: 'Trascina il pin per affinare la posizione esatta.',
    myOutdoors: 'I Miei Spazi',
    myOutdoorsSubtitle: 'Gestisci il tuo inventario di cartelloni',
    viewCalendarTooltip: 'Consulta le date bloccate per questo Outdoor',
    calendarModalTitle: 'Calendario - {{name}}',
    addOutdoor: 'Aggiungi Spazio',
    searchByName: 'Cerca per nome…',
    deleteConfirmNamed: 'Sei sicuro di voler eliminare "{{name}}"? Questa azione non può essere annullata.',
    specifications: 'Specifiche',
    creativeRatio: 'Proporzioni del creativo',
    coordinates: 'Coordinate',
    price: 'Prezzo',
    plusVat: '+ IVA',
    unavailableDates: 'Date non disponibili',
    duration: 'Durata',
    addToCampaign: 'Aggiungi alla Campagna',
    goToCampaign: 'Vai alla Campagna',
    signInToAdd: 'Accedi/Registrati per aggiungere questo Outdoor alla tua Campagna',
    bookingsCalendarTitle: 'Calendario prenotazioni',
    bookingsCalendarSubtitle: 'Scopri quando le tue campagne partono, sono in onda e terminano. Scegli un giorno per vedere gli spazi prenotati.',
    legend_starting: 'Inizio campagna',
    legend_startingDesc: 'Una prenotazione va in onda',
    legend_running: 'Campagna in onda',
    legend_runningDesc: 'Il tuo spazio è in onda',
    legend_finishing: 'Fine campagna',
    legend_finishingDesc: 'Ultimo giorno di una prenotazione',
    legend_blocked: 'Date bloccate',
    legend_blockedDesc: 'Spazi che hai reso non disponibili',
    legend_none: 'Nessuna prenotazione',
    legend_noneDesc: 'Nessuno dei tuoi spazi è prenotato',
    legend_mixed: 'Colori divisi: quel giorno ne vale più di uno',
    calendarToday: 'Oggi',
    selectDayHint: 'Scegli un giorno per vederne le prenotazioni. Clicca di nuovo per deselezionarlo.',
    clearDateSelection: 'Cancella data selezionata',
    dailyStatesError: 'Impossibile caricare le prenotazioni di questo mese. Prova ad aggiornare.',
    searchBookedByName: 'Cerca spazi prenotati per nome…',
    clearSearch: 'Cancella ricerca',
    bookedOutdoorsCount: 'Spazi prenotati: {{count}}',
    noBookingsOnDate: 'Nessuno spazio prenotato in questo giorno',
    noBookedOutdoorsMatch: 'Nessuno spazio prenotato corrisponde a «{{name}}» in questo giorno',
    noBookingsOnDateHint: 'Scegli un altro giorno o cancella la data per vedere tutti i tuoi spazi.',
    bookingPeriod: 'Periodo di prenotazione',
    logIn: 'Accedi',
    register: 'Registrati',
    selectCampaignToAdd: 'Seleziona una campagna per aggiungere questo spazio',
    changeCampaign: 'Cambia',
    alreadyInCampaign: 'Già nella campagna',
    billboardFallback: 'Cartellone Pubblicitario',
    bookMoreThanDays: 'Prenota più di {{count}} giorni',
    percentageOff: '{{percentage}}% di sconto',
    comingSoon: 'I tuoi spazi saranno qui presto!',
    attributes: 'Situato vicino a',
    attributesHint: "Aiuta gli inserzionisti a trovarti più in fretta. Indica cosa c'è nelle vicinanze per aumentare la visibilità del tuo spazio nei risultati di ricerca.",
  },
  outdoorDetail: {
    productionCost: 'Costo di produzione',
    bookingTitle: 'Prenota questo spazio',
    startDate: 'Data di inizio',
    endDate: 'Data di fine',
    estimatedCost: 'Costo stimato',
    addToCart: 'Aggiungi al carrello',
    inCart: 'Già nel carrello',
    specs: 'Specifiche',
    dimensions: 'Dimensioni',
    aspectRatio: 'Proporzioni richieste',
    pricePerDay: 'Prezzo al giorno',
    location: 'Posizione',
    blockedTimes: 'Periodi bloccati',
    discounts: 'Sconti per volume',
    noBlockedTimes: 'Nessun periodo bloccato',
    noDiscounts: 'Nessuno sconto disponibile',
    photos: 'Foto',
    days: 'giorni',
    total: 'Totale',
    discount: 'sconto',
    campaignBookings: 'Prenotazioni di Campagna',
    inCampaign: 'In Campagna',
    minimumNoticeInDays: 'Preavviso minimo di prenotazione',
  },
  campaign: {
    methodFlowLabel: 'Come pagherai',
    methodFirstPayment: '1° pagamento',
    methodCard: 'Carta',
    methodThenMonthly: 'Poi ogni mese',
    methodThenTrimonthly: 'Poi ogni 3 mesi',
    methodDirectDebit: 'Addebito diretto',
    searchByName: 'Cerca campagne per nome…',
    clearSearch: 'Cancella ricerca',
    resultsSummary: 'Risultati: {{total}} · Pagina {{page}} di {{pages}}',
    noSearchResults: 'Nessuna campagna corrisponde a «{{name}}»',
    noSearchResultsHint: 'Controlla l’ortografia o prova un altro nome.',
    eventFeedbackReceived: 'Un fornitore ha risposto sugli spazi della tua campagna.',
    eventConfirmationUpdated: 'La conferma della tua campagna è completata: controlla il nuovo stato.',
    eventViewCampaign: 'Vedi campagna',
    planTrimonthlyTitle: 'Paga ogni 3 mesi',
    planTrimonthlyDesc: 'Paga ora i costi di produzione e i primi 3 mesi. Ogni trimestre successivo viene addebitato il primo giorno tramite addebito diretto.',
    visitCampaignPage: 'Vai alla pagina della campagna',
    payStepNotice: 'La disponibilità degli spazi viene ricontrollata al pagamento: se qualcosa cambia, ti avvisiamo prima dell’addebito.',
    removeOutdoor: 'Rimuovi questo spazio',
    noOutdoorsYetDesc: 'Esplora la mappa per trovare spazi per la tua campagna, poi scegli le date.',
    creativesNeedOutdoors: 'Aggiungi prima gli spazi: le creatività necessarie dipendono dalle loro dimensioni.',
    stepAnnounce: 'Passo {{n}} di {{total}}: {{step}}',
    stepsDone: '{{done}} di {{total}} completati',
    stepDone: 'Completato',
    stepToDo: 'Da fare',
    stepPrevious: 'Indietro: {{step}}',
    stepNext: 'Avanti: {{step}}',
    stepOutdoorsSummary: 'Spazi: {{count}}',
    stepCreativesSummary: '{{done}} di {{total}} pronte',
    stepTermsAccepted: 'Accettati',
    stepTermsPending: 'Non ancora accettati',
    stepPendingHint_outdoors: 'Aggiungi almeno uno spazio per continuare.',
    stepPendingHint_creatives: 'Tutte le creatività richieste devono essere caricate e approvate.',
    stepPendingHint_terms: 'Accetta i termini per sbloccare il pagamento.',
    goToPayment: 'Vai al pagamento',
    acceptTermsStepLabel: 'Ho letto e accetto i Termini e Condizioni di questa campagna.',
    payStepTitle: 'Rivedi e paga',
    payStepMissingTitle: 'Completa questi passaggi per pagare:',
    payStepTotal: 'Totale campagna',
    scheduleTitle: 'Piano dei pagamenti',
    scheduleTotal: 'Totale {{amount}}',
    scheduleFullPayment: 'Pagamento completo',
    scheduleFirstPayment: 'Primo pagamento · {{month}}',
    scheduleDueAtCheckout: 'Addebitato al pagamento',
    scheduleAuthorisedAtCheckout: 'Autorizzato al pagamento, addebitato quando i fornitori confermano',
    scheduleDueOn: 'Il {{date}}',
    schedulePaidOn: 'Pagato il {{date}}',
    scheduleProcessing: 'In elaborazione - gli addebiti diretti richiedono qualche giorno',
    scheduleFailed: 'Pagamento non riuscito',
    scheduleCancelled: 'Annullato - non verrà addebitato',
    scheduleSplit: 'Produzione {{production}} · Giorni di campagna {{ads}}',
    scheduleVatIncluded: 'Tutti gli importi includono l’IVA.',
    paymentsTitle: 'Pagamenti',
    paymentsPaidSoFar: 'Pagato finora',
    paymentsRemaining: 'Restano da pagare {{amount}}',
    paymentsFailedNotice: 'Un addebito diretto non è andato a buon fine. Controlla il tuo conto bancario o contattaci per non interrompere la campagna.',
    paymentPlanTitle: 'Come vuoi pagare?',
    paymentPlanSubtitle: 'Scegli prima del pagamento. Puoi cambiarlo fino al pagamento.',
    planTotalTitle: 'Paga per intero',
    planTotalDesc: 'Un unico pagamento per tutta la campagna.',
    planMonthlyTitle: 'Paga mensilmente',
    planMonthlyDesc: 'Paga ora i costi di produzione e il primo mese. Ogni mese successivo viene addebitato il giorno 1 tramite addebito diretto.',
    paymentPlanError: 'Impossibile aggiornare il piano di pagamento.',
    checkoutAllInstant: 'Tutti gli spazi sono a prenotazione immediata: paghi al checkout e la campagna è confermata subito.',
    checkoutNeedsConfirmation: '{{count}} spazi su {{total}} richiedono la conferma del fornitore. Al checkout la carta viene solo autorizzata: l’addebito avviene quando i fornitori confermano, e solo per gli spazi approvati.',
    mandateStepTitle: 'Passo 1 di 2 · Imposta l’addebito diretto',
    mandateStepDesc: 'Poi effettuerai il primo pagamento con carta.',
    confirmingTitle: 'In attesa della conferma dei fornitori',
    confirmingDesc: 'La tua carta è stata autorizzata, non addebitata. Paghi solo per gli spazi approvati dai fornitori.',
    awaitingDecisionTitle: 'Alcuni spazi non sono disponibili',
    awaitingDecisionDesc: 'Procedi con gli spazi approvati, oppure annulla la campagna e sblocca il pagamento.',
    providersAnswerBy: 'I fornitori rispondono entro il {{date}}',
    decideBy: 'Decidi entro il {{date}}, altrimenti la campagna viene annullata e non viene addebitato nulla.',
    feedbackCount_approved: 'Approvati: {{count}}',
    feedbackCount_confirming: 'In attesa di risposta: {{count}}',
    feedbackCount_unavailable: 'Non disponibili: {{count}}',
    feedbackCount_expired: 'Senza risposta in tempo: {{count}}',
    proceedWithApproved: 'Procedi con gli spazi approvati',
    proceedNoneApproved: 'Nessuno spazio è stato ancora approvato.',
    removeConfirmingHint: 'Puoi ancora rimuovere gli spazi in attesa di risposta.',
    proceedModalTitle: 'Procedere con gli spazi approvati?',
    proceedOutdoorsLabel: 'Spazi prenotati',
    proceedOutdoorsValue: '{{approved}} di {{total}}',
    proceedChargedLabel: 'Ti verrà addebitato',
    proceedTotalMonthlyLabel: 'Totale campagna',
    proceedModalNote: 'Questo importo viene addebitato ora sulla tua carta.',
    proceedModalMonthlyNote: 'Il primo pagamento viene addebitato ora, il resto a rate tramite addebito diretto.',
    proceedModalDropped: 'Gli altri spazi ({{count}}) saranno rimossi da questa campagna.',
    proceedSuccess: 'La tua campagna è confermata.',
    cancelDecisionTitle: 'Annullare questa campagna?',
    cancelDecisionDesc: 'Il pagamento autorizzato viene sbloccato e non viene addebitato nulla. Tutti gli spazi tornano liberi per altri inserzionisti.',
    unavailableTitle: 'Nessuno degli spazi era disponibile',
    unavailableDesc: 'I fornitori non hanno potuto confermare queste date, quindi non è stato addebitato nulla. Prova altre date o altri spazi.',
    feedback_CONFIRMING: 'In attesa del fornitore',
    feedback_APPROVED: 'Approvato',
    feedback_UNAVAILABLE: 'Non disponibile',
    feedback_EXPIRED: 'Nessuna risposta',
    creativeThumbnailAlt: 'Creatività della campagna {{name}}',
    title: 'Campagne',
    newCampaign: 'Nuova Campagna',
    newCampaignTooltip: 'Clicca per creare una nuova campagna',
    mustRegisterAsAdvertiser: 'Devi registrarti come Inserzionista per poter creare Campagne',
    noCampaigns: 'Nessuna campagna ancora',
    noCampaignsDesc: 'Crea la tua prima campagna per iniziare a fare pubblicità esterna.',
    browseSpaces: 'Esplora spazi pubblicitari',
    status: 'Stato',
    from: 'Dal',
    to: 'Al',
    filter: 'Filtra',
    clearFilter: 'Cancella filtro',
    outdoorSlots: 'Spazi Esterni',
    outdoorsColHeader: 'Spazi',
    startDate: 'Data di inizio',
    endDate: 'Data di fine',
    paginationRange: 'Campagne {{from}}-{{to}} di {{total}}',
    creatives: 'Creativi',
    payment: 'Pagamento',
    deleteTitle: 'Elimina Campagna',
    deleteConfirm: 'Sei sicuro di voler eliminare questa campagna? Questa azione non può essere annullata.',
    uploadCreative: 'Carica creativo',
    removeCreative: 'Rimuovi',
    deletingCreative: 'Eliminazione del creativo…',
    creativeRatioMismatch: 'Il rapporto dell\'immagine non corrisponde al formato {{ratio}} richiesto. Carica un\'immagine con le proporzioni corrette o un PDF.',
    getPaymentDetails: 'Ottieni dettagli di pagamento',
    requiredRatios: 'Proporzioni creativi richieste',
    iban: 'IBAN',
    reference: 'Riferimento pagamento',
    viewCampaign: 'Vedi',
    loading: 'Caricamento campagne…',
    noSlots: 'Nessuno slot spazio in questa campagna.',
    noCreatives: 'Nessun creativo caricato ancora.',
    subtitle: 'Gestisci le tue campagne di pubblicità esterna',
    noFound: 'Nessuna campagna trovata',
    noFoundDesc: 'Inizia aggiungendo spazi al carrello per creare la tua prima campagna.',
    browseOutdoors: 'Esplora spazi',
    outdoorsCount: '{{count}} spazio',
    outdoorsCount_plural: '{{count}} spazi',
    creativesCount: '{{count}} creativi',
    paymentLabel: 'Pagamento: {{status}}',
    backToCampaigns: 'Torna alle Campagne',
    checklistTitle: 'Checklist della campagna',
    checklistOutdoors: 'Scegli gli spazi per la tua campagna',
    checklistCreatives: 'Aggiungi creativi',
    checklistTerms: 'Accetta i Termini e Condizioni',
    checklistPay: 'Paga la campagna',
    acceptTermsPrefix: 'Accetto i',
    acceptTermsLink: 'Termini e Condizioni',
    acceptTermsRequiredHint: 'Devi accettare i Termini e Condizioni prima di pagare questa campagna.',
    advertiserTermsModalTitle: 'Termini e Condizioni per Inserzionisti e Campagne',
    advertiserTermsModalHint: 'Queste sono le sezioni dei nostri Termini e Condizioni che si applicano specificamente agli inserzionisti e alle campagne.',
    viewFullTerms: 'Visualizza i Termini e Condizioni completi',
    outdoorsHeader: 'Spazi ({{count}})',
    noOutdoorsYet: 'Nessuno spazio aggiunto ancora.',
    requiredAspectRatios: 'Proporzioni creativi richieste',
    recResolution: 'consigliato: {{w}}×{{h}} cm @ {{dpi}} dpi (1:{{scale}})',
    recInclBleed: 'incl. margine al vivo',
    dimensionsCalculatorBleedNote: 'Questo spazio pubblicitario ha {{bleed}} cm di margine al vivo su ogni lato, quindi le misure coprono l\'intera area di stampa di {{w}} × {{h}} m (l\'area visibile è di {{trimW}} × {{trimH}} m).',
    orientationLandscape: 'Orizzontale',
    orientationPortrait: 'Verticale',
    dimensionsCalculatorTooltip: 'Calcola le possibili dimensioni della creatività',
    dimensionsCalculatorTitle: 'Calcolatore delle dimensioni per una creatività con proporzioni {{ratio}}',
    dimensionsCalculatorHint: "Modifica la larghezza o l'altezza (in centimetri): l'altro lato si aggiorna automaticamente per mantenere queste proporzioni. Lavoriamo sempre a 300 dpi, favorendo una scala 1:10 della dimensione reale dello spazio pubblicitario.",
    dimensionsCalculatorWidthLabel: 'Larghezza (cm)',
    dimensionsCalculatorHeightLabel: 'Altezza (cm)',
    dimensionsCalculatorDpiLabel: 'Risoluzione di stampa',
    dimensionsCalculatorScaleHint: 'Scala: 1:{{scale}} - raccomandiamo 1:10 o un design più grande (numero di scala minore).',
    dimensionsCalculatorExportHint: 'Esporta il tuo file a {{w}} × {{h}} px.',
    dimensionsCalculatorMinQualityWidth: 'Troppo piccolo per una buona qualità di stampa - servono almeno {{min}} cm per un design in scala 1:{{scale}}.',
    dimensionsCalculatorMinQualityHeight: 'Troppo piccolo per una buona qualità di stampa - servono almeno {{min}} cm per un design in scala 1:{{scale}}.',
    processingImage: 'Elaborazione immagine...',
    noCreativesYet: 'Nessun creativo caricato ancora',
    creativesNote: 'Queste sono le immagini che verranno mostrate sugli spazi pubblicitari outdoor durante la tua campagna.',
    clickToUpload: 'Clicca per caricare',
    creativeValid: 'Approvato',
    creativeUnderReview: 'In revisione',
    creativeInvalid: 'Non valido',
    deleteCreativeTitle: 'Eliminare il creativo?',
    deleteCreativeBody: 'Questo creativo è stato approvato o è in revisione. Eliminandolo verrà rimosso dalla campagna e sarà necessario caricarlo nuovamente.',
    campaignInfo: 'Info Campagna',
    details: 'Dettagli',
    requestPayment: 'Richiedi Pagamento',
    paymentDetails: 'Dettagli Pagamento',
    currency: 'Valuta',
    bankTransferDetails: 'Dettagli bonifico bancario',
    amount: 'Importo',
    importantRef: '⚠️ Importante - Riferimento Pagamento',
    refNote: 'Devi includere questo riferimento nella descrizione del bonifico affinché venga abbinato automaticamente.',
    deleteCampaign: 'Elimina Campagna',
    deleteCampaignDesc: 'Questo eliminerà definitivamente questa campagna e tutti i dati associati. Questa azione non può essere annullata.',
    addOutdoor: 'Aggiungi Spazio',
    outdoorAdded: 'Spazio aggiunto alla campagna',
    selectOutdoor: 'Seleziona uno spazio',
    outdoorDateConflict: 'Questo spazio è già prenotato in questa campagna per date sovrapposte. Scegli date diverse.',
    alreadyInCampaign: 'In campagna',
    name: 'Nome',
    outdoorSubtotal: 'Subtotale',
    bankTransferNoticeTitle: 'Pagamento Campagna Richiesto',
    bankTransferNotice: 'La campagna verrà attivata e tutti gli spazi formalmente prenotati solo a seguito della conferma integrale del pagamento. Clicca su "Valida e Paga" per procedere. Nota: la disponibilità degli spazi pubblicitari viene rivalidata al momento del pagamento - gli spazi disponibili quando aggiunti alla campagna potrebbero non essere più garantiti.',
    requestPaymentDisabledHint: 'Tutti i {{count}} creativi richiesti devono essere caricati e validati (stato: Valido) prima di poter richiedere il pagamento.',
    outdoorRemoved: 'Spazio rimosso dalla campagna.',
    removeOutdoorConfirm: 'Sei sicuro di voler rimuovere questo spazio dalla campagna? Questa azione non può essere annullata.',
    qualityFail: 'Risoluzione troppo bassa - file non caricato',
    qualityWarn: 'Proporzioni non corrispondenti - l\'immagine potrebbe essere ritagliata o avere margini',
    qualityAspectMismatch: 'Proporzione {{actual}} vs {{expected}} (outdoor)',
    qualityUploadAnyway: 'Carica comunque',
    qualityConfirmHint: 'L\'immagine potrebbe essere ritagliata o avere margini per adattarsi a questo formato.',
    qualityDetailFail: 'Questo file è sufficientemente nitido solo per {{achievedScale}} su uno spazio pubblicitario di {{outdoorW}} × {{outdoorH}} m.',
    qualityTargetFail: 'Progetta la tua creatività a {{w}} × {{h}} cm (scala 1:{{scale}}, {{dpi}} dpi) per questo formato.',
    recResolutionPx: 'consigliato: {{w}}×{{h}}px @ {{dpi}} dpi',
    dimensionsCalculatorHintPx: "Modifica la larghezza o l'altezza: l'altro lato si aggiorna automaticamente per mantenere queste proporzioni e il DPI effettivo viene ricalcolato, così puoi trovare dimensioni alternative che mantengano comunque una buona qualità di stampa.",
    dimensionsCalculatorWidthLabelPx: 'Larghezza (px)',
    dimensionsCalculatorHeightLabelPx: 'Altezza (px)',
    dimensionsCalculatorDpiLabelPx: 'DPI effettivo',
    dimensionsCalculatorMinDpiHintPx: 'Per questo spazio pubblicitario sono richiesti almeno {{dpi}} dpi.',
    dimensionsCalculatorMinQualityWidthPx: 'Qualità minima della larghezza non ancora raggiunta (min. {{min}}px, consigliato: {{rec}}px).',
    dimensionsCalculatorMinQualityHeightPx: "Qualità minima dell'altezza non ancora raggiunta (min. {{min}}px, consigliato: {{rec}}px).",
    qualityWarnLowRes: 'Bassa risoluzione - l\'immagine potrebbe stamparsi male',
    qualityConfirmHintLowRes: 'L\'immagine potrebbe stamparsi con perdita di qualità visibile.',
    qualityDetailWarnPx: '{{pixelW}} × {{pixelH}} px danno {{dpi}} DPI a dimensione intera.',
    qualityDetailFailPx: '{{pixelW}} × {{pixelH}} px danno {{dpi}} DPI a {{outdoorW}} × {{outdoorH}} m, al di sotto del minimo di {{minDpi}} DPI.',
    qualityTargetWarnPx: 'Raccomandiamo almeno {{recDpi}} DPI per questo formato: {{recW}} × {{recH}} px, o {{recScaleLabel}}.',
    qualityTargetFailPx: 'Servono almeno {{minW}} × {{minH}} px - lavorando a 1:{{scale}}, è una tela di {{canvasW}} × {{canvasH}} m a {{designDpi}} DPI.',
    creativeUnitLabel: 'Unità di misura',
    creativeUnitCm: 'Centimetri',
    creativeUnitPx: 'Pixel',
    creativeUnitHint: 'Scegli come vengono mostrate e verificate le dimensioni consigliate delle creatività. Centimetri: progetta in scala 1:10 dello spazio pubblicitario, sempre a 300 dpi. Pixel: risoluzione minima in base alle dimensioni dello spazio pubblicitario.',
    previewBadge: 'Anteprima',
    previewOnlyHint: 'Solo anteprima - scarica l\'originale per la stampa',
    downloadPrintFile: 'Scarica il file di stampa',
    downloadPrintFileHint: 'Originale a piena risoluzione',
    printFileExplainer: 'L\'immagine qui sopra è un\'anteprima leggera. Scarica il file originale, a piena risoluzione, da inviare in stampa.',
    previewFailed: 'Non è stato possibile preparare un\'anteprima di questo file nel tuo browser. Esportalo in JPG o PNG e riprova.',
    creativeFileRequirements: 'File accettati: TIF, TIFF, JPG, JPEG, PNG o PDF. La stampa richiede la modalità colore CMYK. Le immagini in altre modalità vengono convertite in CMYK, con un\'anteprima da approvare prima del caricamento. I file PDF devono essere già in CMYK.',
    creativeFormatNotAllowed: '"{{name}}" non è un tipo di file accettato. Carica un file TIF, TIFF, JPG, JPEG, PNG o PDF.',
    creativeNotCmykPdf: '"{{name}}" contiene colori RGB (nella grafica o in un\'immagine incorporata). I file di stampa devono essere interamente in CMYK - esportalo di nuovo con un profilo colore CMYK (es. PDF/X-1a) e caricalo.',
    creativeUnreadable: 'Non è stato possibile leggere "{{name}}". Potrebbe essere danneggiato o salvato in modo insolito - esportalo di nuovo e riprova.',
    cmykNoticeTitle: '"{{name}}" non è in modalità colore CMYK',
    cmykNoticeBody: 'La stampa richiede il CMYK. Possiamo convertirlo per te con il profilo standard per la stampa in esterni e potrai rivedere un\'anteprima prima/dopo prima di qualsiasi caricamento.',
    cmykConvert: 'Converti in CMYK',
    cmykModalTitle: 'Converti in CMYK per la stampa',
    cmykConverting: 'Conversione in CMYK ({{profile}})…',
    cmykBefore: 'Originale',
    cmykAfter: 'Anteprima di stampa (CMYK)',
    cmykShiftWarning: 'Alcuni colori vivaci appariranno sensibilmente diversi in stampa (circa il {{percent}}% dell\'immagine). Se i colori esatti sono importanti, modifica la grafica nel tuo software prima di caricarla.',
    cmykProfileNote: 'Convertito con il profilo {{profile}}, lo standard per la stampa in esterni. Gli schermi non possono mostrare il CMYK con precisione, quindi l\'anteprima simula il risultato stampato.',
    cmykAccept: 'Accetta la versione CMYK convertita',
    cmykErrorUnavailable: 'La conversione in CMYK non è al momento disponibile. Converti il file in CMYK nel tuo software di grafica e caricalo di nuovo.',
    cmykErrorTooLarge: 'Questa immagine è troppo grande per essere convertita nel browser. Convertila in CMYK nel tuo software di grafica e caricala di nuovo.',
    cmykErrorFailed: 'Non è stato possibile convertire questo file. Convertilo in CMYK nel tuo software di grafica e caricalo di nuovo.',
    pay: 'Valida e Paga',
    commission: 'Commissione piattaforma ({{rate}}%)',
    vatLabel: 'IVA',
    vatWithRate: 'IVA ({{rate}}%)',
    vatDetailsTitle: 'Dettagli IVA',
    vatDetailsBody: "L'IVA viene calcolata in base al trattamento fiscale applicabile a ciascuna componente della campagna. Alcuni importi possono includere l'IVA, essere soggetti a un'aliquota IVA diversa o non rientrare nella base imponibile IVA applicabile.",
    totalWithoutVat: 'Totale (IVA esclusa)',
    grandTotal: 'Totale',
    dailyRateRoundingNote: 'Le tariffe giornaliere sono arrotondate al centesimo più vicino.',
    platformFeeNote: '* Le tariffe giornaliere degli spazi includono già una commissione di piattaforma del 5%.',
    confirmPayment: 'Conferma pagamento',
    paymentSuccess: 'Pagamento riuscito! La tua campagna verrà attivata a breve.',
    checkingPayment: 'Verifica del pagamento in corso…',
    paymentConfirmed: 'Pagamento Confermato!',
    paymentConfirmedDesc: 'Il tuo pagamento è stato confermato. La tua campagna verrà attivata a breve.',
    paymentPending: 'Pagamento Non Confermato',
    paymentPendingDesc: 'Il tuo pagamento non ha potuto essere confermato al momento. Riprova o contatta il supporto.',
    backToCampaign: 'Torna alla Campagna',
    expandPricing: 'Mostra dettagli prezzi',
    collapsePricing: 'Nascondi dettagli prezzi',
    availabilityUpdated: "Uno o più spazi sono stati rimossi dalla sua campagna - erano stati prenotati da un'altra campagna per date sovrapposte, oppure il periodo di preavviso minimo era già scaduto. Si prega di verificare la selezione aggiornata di seguito.",
    availabilityDialogTitle: 'Conferma disponibilità e procedi al pagamento',
    availabilityDialogBody: 'Prima di procedere, verificheremo che tutti gli spazi selezionati siano ancora disponibili. Alcuni potrebbero essere stati prenotati da altre campagne nel frattempo. Indica come gestire eventuali conflitti.',
    availabilityRemoveYes: 'Sì - rimuovi automaticamente gli spazi non disponibili',
    availabilityRemoveYesDesc: 'Gli spazi non più disponibili verranno rimossi da questa campagna. Potrai revisionare la selezione aggiornata prima del pagamento.',
    availabilityRemoveNo: 'No - segnala i conflitti e gestiscili manualmente',
    availabilityRemoveNoDesc: 'Gli spazi in conflitto verranno evidenziati così da poter modificare le date o rimuoverli manualmente.',
    availabilityDialogConfirm: 'Procedi al pagamento',
    outdoorFlaggedTitle: 'Date non più disponibili',
    outdoorFlaggedDesc: 'Questo spazio è stato prenotato da un\'altra campagna per date sovrapposte. Modifica le date o rimuovilo per procedere.',
    outdatedOutdoorsTitle: 'La campagna non può procedere - rilevati placement non aggiornati',
    outdatedOutdoorsDesc: 'Uno o più spazi outdoor hanno una data di inizio già trascorsa. Il pagamento non è stato elaborato. Controlla i placement evidenziati e aggiorna le date di inizio prima di riprovare.',
    outdoorOutdatedTitle: 'Data di inizio nel passato',
    outdoorOutdatedDesc: 'La data di inizio programmata per questo placement è già trascorsa. Aggiornala con una data futura per continuare.',
    pastStartDatesToast: 'Le date della campagna non possono essere nel passato.',
    cancelCampaign: 'Annulla campagna',
    cancelCampaignConfirm: 'Questa azione annullerà definitivamente la sua campagna. È sicuro?',
    cancelCampaignYes: 'Sì, annulla',
    cancelCampaignAbort: 'Mantieni campagna',
    cancelledSuccess: 'La campagna è stata annullata.',
    cancellationPolicyPending: 'Cancellazione gratuita - nessun addebito si applica finché la campagna è in stato In attesa.',
    cancellationPolicyReady: 'Cancellazione gratuita se tutti gli outdoor vengono cancellati con più giorni di preavviso rispetto al periodo minimo del rispettivo Fornitore di Spazi. Si applica una commissione di cancellazione se uno o più outdoor rientrano nel loro periodo di preavviso minimo (più IVA per le aziende portoghesi). I costi di produzione (stampa, allestimento, ecc.) non sono rimborsabili per qualsiasi outdoor entro il suo periodo di preavviso minimo.',
    cancellationPolicyRunning: 'Attenzione: la cancellazione di una campagna già in corso comporta la perdita del 100% del valore della campagna. Non verrà emesso alcun rimborso.',
    ppInvoices: 'Fatture dei Fornitori di Spazio',
    outdoorAdj0: 'straordinari',
    outdoorAdj1: 'fantastici',
    outdoorAdj2: 'magnifici',
    outdoorAdj3: 'favolosi',
    outdoorAdj4: 'eccezionali',
    outdoorsCollapsedSummary: 'Qui abbiamo {{count}} outdoors {{adj}}!',
    messages: 'Messaggi',
    noMessages: 'Nessun fornitore di spazi ha ancora inviato messaggi riguardanti questa campagna. Quando lo faranno, le loro conversazioni appariranno qui.',
    noMessagesYet: 'Nessun messaggio in questa conversazione ancora.',
    typeMessage: 'Scrivi un messaggio…',
    instructions: 'Istruzioni per i Fornitori di Spazi',
    instructionsPlaceholder: 'es. Si prega di mostrare questa campagna solo dalle 8 alle 22.',
    instructionsEmpty: 'Nessuna istruzione aggiunta. Clicca su Modifica per aggiungere indicazioni.',
    instructionsSaved: 'Istruzioni salvate.',
    proofOfDisplay: 'Prova di Esposizione',
    proofPending: 'Prova in arrivo',
    proofPendingDesc: 'Il tuo fornitore di spazio caricherà la prova di esposizione a breve.',
    proofAlt: 'Prova di esposizione – {{name}}',
    additionalFiles: 'File aggiuntivi',
    additionalFilesSubtitle: 'Materiale di supporto per questa campagna - non obbligatorio.',
    additionalFilesSubtitlePP: "Materiale di supporto condiviso dall'inserzionista.",
    noAdditionalFiles: 'Nessun file aggiuntivo caricato ancora.',
    uploadFile: 'Carica file',
    fileUploaded: 'File caricato con successo.',
    fileDeleted: 'File rimosso.',
    deleteFile: 'Elimina file',
    addOutdoors: 'Aggiungi spazi outdoor',
    creativesLockedTitle: 'Nessuno spazio outdoor aggiunto',
    creativesLockedDesc: 'I creativi devono corrispondere alla risoluzione richiesta da ogni spazio. Aggiungi almeno uno spazio per abilitare i caricamenti.',
    editDates: 'Modifica date',
    updateDates: 'Aggiorna date',
    datesUpdated: 'Date aggiornate con successo',
  },
  dashboard: {
    title: 'Dashboard',
    earnings: 'Guadagni',
    spendings: 'Spese',
    last30: 'Ultimi 30 giorni',
    last90: 'Ultimi 90 giorni',
    thisYear: "Quest'anno",
    accessRequests: 'Richieste di Accesso',
    noRequests: 'Nessuna richiesta in attesa',
    approve: 'Approva',
    reject: 'Rifiuta',
    teamInvite: 'Invita Membro del Team',
    inviteEmail: 'Indirizzo e-mail',
    sendInvite: 'Invia Invito',
    totalEarned: 'Totale guadagnato',
    totalSpent: 'Totale speso',
    activeOutdoors: 'Spazi attivi',
    activeCampaigns: 'Campagne attive',
    overview: 'Panoramica',
    howPaidTitle: 'Come vieni pagato',
    howPaidDesc: 'Quando una campagna è attiva, carica le prove fotografiche per ogni cartellone. Quando tutte le prove sono verificate, il pagamento viene rilasciato automaticamente. Il tuo pagamento viene calcolato in base alla tua tariffa giornaliera moltiplicata per il numero di giorni attivi della campagna, al netto di una commissione di servizio piattaforma del 5% applicata per prenotazione.',
    ppOverview: 'Panoramica Fornitore di Spazi',
    advertiserOverview: 'Panoramica Inserzionista',
    findOutdoors: 'Trova Spazi',
    addOutdoor: 'Aggiungi Spazio',
    viewCampaigns: 'Vedi Campagne',
    manageOutdoors: 'Gestisci Spazi',
    companyDetails: 'Dettagli Azienda',
    userDetails: "Dettagli dell'account",
    pendingRequests: 'Richieste di Accesso in Sospeso ({{count}})',
    inviteDesc: "Riceveranno un'e-mail con un link per unirsi alla tua azienda su Scapow.",
    invitePlaceholder: 'collega@azienda.com',
    invoicesTitle: 'Fatture',
    downloadInvoice: 'Scarica',
    invoiceIssued: 'Emessa',
    invoicePaid: 'Pagata',
    invoiceUnknownCampaign: 'Campagna sconosciuta',
    invoicesSubtitle: 'La tua cronologia dei pagamenti e le fatture scaricabili.',
    invoicesEmpty: 'Non vediamo l\'ora di popolare questa sezione per te!',
  },
  invoices: {
    title: 'Fatture',
    subtitleAdvertiser: 'Fatture di Scapow e dei fornitori di spazi per tutte le tue campagne.',
    subtitlePP: 'La tua cronologia dei pagamenti e le fatture scaricabili.',
    issued: 'Emessa il',
    download: 'Scarica',
    empty: 'Nessuna fattura ancora. Appariranno qui una volta elaborate le tue campagne.',
    unknownCampaign: 'Campagna sconosciuta',
    ppInvoices: 'Fatture fornitori ({{count}})',
    unknownProvider: 'Fornitore sconosciuto',
    notAvailable: 'Non disponibile',
    typeInvoice: 'Fattura',
    typeCreditNote: 'Nota di credito',
  },
  payments: {
    title: 'Pagamenti',
    subtitle: 'La tua cronologia dei pagamenti per le campagne sui tuoi spazi.',
    empty: 'Nessun pagamento ancora. Appariranno qui una volta liquidate le tue campagne.',
    unknownCampaign: 'Campagna sconosciuta',
    columnId: 'ID pagamento',
    columnCampaign: 'Campagna',
    columnValue: 'Valore',
    columnPaidAt: 'Pagato il',
    columnStatus: 'Stato',
    statusPaid: 'Pagato',
    statusTransferRequested: 'Bonifico richiesto',
  },
  userDetails: {
    receiveEmails: 'Ricevi email',
    receiveEmailsOnDesc: 'Le email della piattaforma vengono inviate a {{email}}.',
    receiveEmailsOffDesc: 'Non riceverai email dalla piattaforma. Attiva per riceverle di nuovo.',
    emailsTurnedOn: 'Riceverai le email della piattaforma.',
    emailsTurnedOff: 'Non riceverai più email dalla piattaforma.',
    emailsUpdateError: 'Impossibile aggiornare la tua preferenza email.',
    title: "Dettagli dell'account",
    subtitle: 'Gestisci le informazioni del tuo account personale.',
    name: 'Nome',
    editName: 'Clicca per modificare',
    email: 'Email',
    memberSince: 'Membro dal (UTC)',
    accountStatus: "Stato dell'account",
    statusVerified: 'Verificato',
    statusPending: 'Verifica in sospeso',
    nameUpdated: 'Nome aggiornato con successo.',
    nameRequired: 'Inserisci un nome valido (almeno 2 caratteri).',
    password: 'Password',
    changePassword: 'Cambia password',
    currentPassword: 'Password attuale',
    newPassword: 'Nuova password',
    confirmNewPassword: 'Conferma nuova password',
    passwordUpdated: 'Password aggiornata con successo.',
    passwordFieldsRequired: 'Compila tutti i campi della password.',
    passwordTooShort: 'La nuova password deve contenere almeno 8 caratteri.',
    passwordSameAsCurrent: 'La nuova password deve essere diversa dalla password attuale.',
    passwordMismatch: 'La nuova password e la conferma non corrispondono.',
  },
  admin: {
    tabUnpaidInstallments: 'Rate non pagate',
    unpaidInstallmentsIntro: 'Rate ancora non pagate 6 giorni dopo la scadenza, dalle più vecchie.',
    noUnpaidInstallments: 'Nessuna rata non pagata.',
    installmentOf: 'Rata {{number}} di {{total}}',
    installmentNumber: 'Rata {{number}}',
    installmentDue: 'Scadenza {{date}}',
    installmentOverdueDays_one: '{{count}} giorno di ritardo',
    installmentOverdueDays_other: '{{count}} giorni di ritardo',
    proofOfCompany: 'Documento aziendale',
    openProofOfCompany: 'Apri {{name}} in una nuova scheda',
    noProofOfCompany: 'Nessun documento aziendale caricato',
    proofLocationLoading: 'Ricerca dell’indirizzo…',
    proofLocationViewMap: 'Vedi sulla mappa',
    title: 'Pannello di Amministrazione',
    verifications: 'Verifiche',
    advertisers: 'Inserzionisti',
    providers: 'Fornitori',
    payments: 'Pagamenti',
    noVerifications: 'Nessuna verifica in attesa',
    noPayments: 'Nessun pagamento in attesa',
    markAsDone: 'Segna come completato',
    business: 'Azienda',
    type: 'Tipo',
    status: 'Stato',
    actions: 'Azioni',
    approve: 'Approva',
    reject: 'Rifiuta',
    subtitle: 'Gestione e moderazione della piattaforma',
    proofVerification: 'Verifiche Manuali',
    accessRequestsTab: 'Richieste di Accesso',
    noAccessRequests: 'Nessuna richiesta di accesso in attesa.',
    noAdvertisers: 'Nessun inserzionista trovato.',
    noProviders: 'Nessun fornitore trovato.',
    noPaymentsStatus: 'Nessun pagamento con questo stato.',
    campaignOutdoor: 'Spazio campagna: {{id}}',
    campaignFrom: 'Campagna del {{date}}',
    adCreative: 'Creativo pubblicitario',
    proofPhotos: 'Foto prove ({{count}}) - clicca per aprire a dimensione intera',
    period: 'Periodo',
    outdoorsLabel: 'spazi',
    campaignsLabel: 'campagne',
    spentLabel: 'speso',
    earnedLabel: 'guadagnato',
    markAsPaid: 'Segna come Pagato',
    tabAds: 'Annunci',
    tabBusinessProofs: 'Prove Aziendali',
    tabProofOfAds: 'Prove degli Annunci',
    approved: 'Approvato',
    rejected: 'Rifiutato',
    noAds: 'Nessuna verifica annuncio in attesa.',
    noBusinessProofs: 'Nessuna prova aziendale in attesa.',
    noProofOfAds: 'Nessuna prova di annuncio in attesa.',
    refundsTab: 'Rimborsi e Debiti',
    refundsSearchPlaceholder: 'Cerca per nome campagna o inserzionista…',
    refundsNoCampaigns: 'Nessuna campagna trovata.',
    refundsSelectOutdoors: 'Seleziona outdoor da rimborsare',
    refundsSelectAll: 'Seleziona tutti',
    refundsDeselectAll: 'Deseleziona tutti',
    refundsNoEligible: 'Nessun outdoor idoneo trovato per questa campagna.',
    refundsEligibleNote: 'Solo gli outdoor non rifiutati sono idonei al rimborso.',
    refundsSubmit: 'Elabora rimborso',
    refundsSuccess: 'Rimborso elaborato con successo.',
    refundsSubTabRefunds: 'Rimborsi Inserzionisti',
    refundsSubTabDebts: 'Debiti Fornitori',
    refundTypeTotal: 'Totale',
    refundTypePartial: 'Parziale',
    refundDaysLabel: 'Giorni da rimborsare',
    refundDaysHint: 'Max {{max}} giorni',
    debtNoDebts: 'Nessun debito fornitore in sospeso.',
    debtSettle: 'Salda',
    debtSettleAmount: 'Importo saldo',
    debtSettleDoc: 'Documento di saldo',
    debtSettleDocHint: 'Carica il documento di saldo firmato (PDF, immagine, ecc.)',
    debtSettleConfirm: 'Carica e salda',
    debtSettleSuccess: 'Debito saldato e documento caricato con successo.',
    debtStatusOutstanding: 'In sospeso',
    debtStatusSettled: 'Saldato',
    debtCampaign: 'Campagna',
    campaignsTab: 'Campagne',
    noCampaigns: 'Nessuna campagna trovata.',
    accessRequestFor: 'Richiesta accesso a: {{entity}}',
    tabByStatus: 'Per stato',
    tabTransferRequested: 'Trasferimento richiesto',
    checkPayment: 'Verifica',
    lastCheckedAt: 'Ultima verifica',
    neverChecked: 'Mai verificato',
    noTransferRequested: 'Nessun pagamento con trasferimento richiesto.',
    checkSuccess: 'Verifica pagamento avviata.',
    revenueTitle: 'Ricavi',
    revenueSubtitle: 'Commissione della piattaforma e IVA per periodo di fatturazione',
    revenueGross: 'Ricavo lordo',
    revenueCommission: 'Commissione',
    revenueVat: 'IVA',
    revenueStripeFees: 'Commissioni Stripe',
    revenueNet: 'Ricavo netto',
    revenueEmpty: 'Nessun ricavo registrato per questo periodo.',
    revenueMonth: 'Mese',
    revenueYear: 'Anno',
    revenueDailyTitle: 'Dettaglio Giornaliero',
    revenueNoDaily: 'Nessun dato giornaliero per questo periodo.',
    searchByName: 'Cerca per nome…',
    importOutdoorsFromFile: 'Importa outdoor da file',
    chooseFile: 'Scegli file…',
    csvSend: 'Invia',
    importOutdoorsSuccess: 'File outdoor inviato con successo.',
    remainingFreeCommissions: 'Commissioni gratuite rimanenti: {{count}}',
    setFreeCommissions: 'Imposta le nuove commissioni gratuite rimanenti',
    freeCommissionsUpdated: 'Commissioni gratuite rimanenti aggiornate.',
    freeCommissionsUpdateFailed: 'Impossibile aggiornare le commissioni gratuite rimanenti.',
    verified: 'Verificato',
  },
  ppCampaigns: {
    searchAllStatuses: 'Vengono mostrate campagne in tutti gli stati. Cancella la ricerca per filtrare per stato.',
    typeAll: 'Tutte',
    typeScapow: 'Scapow',
    typeOffline: 'Offline',
    typeFilterLabel: 'Tipo di campagna',
    noOfflineResults: 'Nessuna campagna offline per ora. Aggiungi spazi a una dalla pagina Spazi.',
    goToOutdoors: 'Vai agli Spazi',
    offlineBadge: 'Offline',
    moreOutdoors: '+{{count}} altri',
    offlineNotes: 'Note',
    payoutCommission: 'Commissione della piattaforma',
    payoutCommissionVat: 'IVA sulla commissione della piattaforma',
    payoutTransferred: 'Trasferito',
    payoutValueWithoutVat: 'Valore pubblicitario (IVA esclusa)',
    payoutVat: 'IVA',
    payoutProduction: 'Costi di produzione (IVA inclusa)',
    payoutsTitle: 'Pagamenti a te',
    payoutsCount: 'Pagamenti: {{count}}',
    payoutsReceived: 'Ricevuto finora',
    payoutFull: 'Pagamento completo',
    payoutFirst: 'Primo pagamento · {{month}}',
    payoutAfterProof: 'Previsto dal {{date}}, dopo l’approvazione della prova di esposizione',
    payoutExpectedOn: 'Previsto il {{date}}',
    payoutReceivedOn: 'Ricevuto il {{date}}',
    payoutProcessing: 'Bonifico in corso',
    payoutOnHold: 'In attesa: l’addebito diretto dell’inserzionista non è riuscito',
    payoutsOnHoldNotice: 'Un pagamento è in attesa perché l’addebito diretto dell’inserzionista non è riuscito. Verrà sbloccato appena quel pagamento andrà a buon fine.',
    payoutsNetNote: 'Importi al netto della commissione Scapow e della relativa IVA, prima di eventuali debiti in sospeso.',
    colProduction: 'Produzione',
    title: 'Campagne',
    subtitle: 'Monitora e gestisci le campagne che includono i tuoi spazi outdoor.',
    tabPending: 'In attesa',
    tabReady: 'Pronte',
    tabRunning: 'In corso',
    tabCompleted: 'Completate',
    noResults: 'Nessuna campagna trovata per questo stato.',
    outdoorSlots: '{{count}} spazio outdoor',
    outdoorSlots_plural: '{{count}} spazi outdoor',
    instructions: "Istruzioni dell'inserzionista",
    backToCampaigns: 'Torna alle Campagne',
    yourSlots: 'I Tuoi Spazi Outdoor',
    noSlots: 'Nessuno spazio outdoor della tua proprietà trovato in questa campagna.',
    advertiserInstructions: "Istruzioni dell'Inserzionista",
    messagesWithAdvertiser: "Messaggi con l'Inserzionista",
    noConversation: "Ancora nessun messaggio. Inizia una conversazione con l'inserzionista scrivendo qui sotto.",
    myInvoice: "La Mia Fattura all'Inserzionista",
    uploadInvoice: 'Carica Fattura',
    replaceInvoice: 'Sostituisci Fattura',
    uploadInvoiceSuccess: 'Fattura caricata con successo.',
    invoiceUploaded: 'Visualizza fattura',
    noInvoiceYet: 'Nessuna fattura ancora caricata.',
    creativesAndOutdoors: 'Creatività e i tuoi spazi',
    noCreativeForRatio: 'Nessuna creatività caricata per questo formato.',
    yourOutdoorsForFormat: 'I tuoi spazi per questo formato',
    viewOutdoor: 'Visualizza spazio',
    goToCampaign: 'Vai alla pagina della campagna',
    yourEarnings: 'I tuoi guadagni',
    readyPaymentTitle: 'Verifica degli spazi richiesta',
    readyPaymentNoteReady: 'I tuoi guadagni sono garantiti in attesa del lancio della campagna. Una volta attiva, carica la prova di allestimento per ogni spazio outdoor per avviare il pagamento.',
    readyPaymentNote: 'Per sbloccare i tuoi guadagni, carica la prova di allestimento per ogni spazio outdoor tramite il passaggio Verifica gli spazi.',
    readyPaymentCta: 'Vai a Verifica gli spazi',
    paymentPaidTitle: 'Pagamento ricevuto',
    paymentPaidDesc: 'I tuoi guadagni per questa campagna sono stati liquidati.',
    viewBreakdown: 'vedi dettaglio',
    earningsBreakdown: 'Dettaglio guadagni',
    colDays: 'Giorni',
    colNetDailyValue: 'Valore Giornaliero + IVA',
    colEarnings: 'Ricavi',
  },
  upcomingCampaigns: {
    title: 'Campagne Imminenti',
    subtitle: 'Campagne pronte al lancio che includono i tuoi spazi pubblicitari.',
    noResults: 'Nessuna campagna imminente trovata.',
  },
  getPaid: {
    title: 'Ricevere Pagamento',
    subtitle: 'Segui i passaggi per verificare le tue affissioni e ricevere il pagamento.',
    step1: { label: 'Campagne Imminenti', desc: 'Ottieni i Creativi per configurare le Affissioni' },
    step2: { label: 'Verifica Affissioni', desc: "Carica la prova dell'annuncio per ricevere il pagamento" },
    step3: { label: 'Fatture Pagate', desc: 'La tua cronologia dei pagamenti' },
    paidOn: 'Pagato il',
    downloadInvoice: 'Fattura',
    noPayments: 'Nessun pagamento ancora',
    noPaymentsDesc: 'Completa il passaggio di verifica per sbloccare il pagamento.',
    upcomingEmpty: 'Nessuna campagna imminente al momento. Riprova più tardi.',
    goToVerify: 'Vai a Verifica Affissioni',
    goToPaid: 'Visualizza Pagamenti',
    goToUpcoming: 'Visualizza Campagne Imminenti',
  },
  cart: {
    title: 'Il tuo Carrello',
    empty: 'Il tuo carrello è vuoto',
    emptyDesc:
      'Cerca spazi pubblicitari e aggiungili al carrello per creare una campagna.',
    browseOutdoors: 'Esplora Spazi Esterni',
    campaignDetails: 'Dettagli Campagna',
    campaignName: 'Nome campagna',
    description: 'Descrizione (opzionale)',
    subtotal: 'Subtotale',
    total: 'Totale',
    remove: 'Rimuovi',
    placeOrder: 'Crea Campagna',
    creating: 'Creazione…',
    estimatedCost: 'Costo stimato',
    signInTitle: 'Accedi per continuare',
    signInDesc: 'Crea un account o accedi per creare la tua campagna.',
    buildCampaign: 'Crea Campagna',
    estimatedTotal: 'Totale stimato',
    campaignNamePlaceholder: 'Campagna Estate 2026',
    detailsPlaceholder: 'Eventuali note...',
    campaignLabel: 'Campagna {{n}}',
    selectCampaign: 'Aggiungi alla campagna:',
    signInToCheckout: 'Accedi per creare questa campagna',
    advertiserRequired: 'Hai bisogno di un account Inserzionista per creare campagne',
    instructions: 'Istruzioni per i Fornitori di Spazi (opzionale)',
    instructionsPlaceholder: 'Eventuali istruzioni speciali per i Fornitori di Spazi vanno inserite qui...',
    instructionsHint: 'Puoi aggiornare questo campo dopo la creazione della campagna.',
  },
  invitations: {
    title: 'Inviti Utenti',
    subtitle: 'Gestisci gli inviti dei membri del team per la tua azienda',
    pendingTitle: 'Inviti in sospeso',
    noPending: 'Nessun invito in sospeso',
    noPendingDesc: 'Invita un membro del team sopra per iniziare.',
    sentAt: 'Inviato',
    cancel: 'Annulla',
    inviteSuccess: 'Invito inviato con successo.',
    inviteError: "Invio dell'invito non riuscito.",
    cancelSuccess: 'Invito annullato.',
    formTitle: 'Invita Membro del Team',
    formDesc: "Riceveranno un'e-mail con un link per unirsi alla tua azienda su Scapow.",
    formPlaceholder: 'collega@azienda.com',
    formSend: 'Invia Invito',
  },
  terms: {
    back: 'Indietro',
    title: 'Termini e Condizioni',
    effectiveDate: 'Data di entrata in vigore: 19 giugno 2026 · SCAPOW · Codify, Unipessoal Lda',
    introBanner: 'Registrando un account, accedendo o utilizzando la Piattaforma, accetti di essere legalmente vincolato da questi Termini. Se non sei d\'accordo, non devi utilizzare la Piattaforma.',
    footerNote: 'SCAPOW · Codify, Unipessoal Lda · In vigore dal 19 giugno 2026',
    s1: 'Introduzione',
    s1_p1: 'I presenti Termini e Condizioni ("Termini") disciplinano l\'accesso e l\'utilizzo della piattaforma SCAPOW ("Piattaforma"), gestita da Codify, Unipessoal Lda ("Società", "noi", "nostro", "ci").',
    s1_p2: 'La Piattaforma funziona come un mercato digitale che collega:',
    s1_i1Bold: 'Inserzionisti',
    s1_i1Rest: ', che desiderano acquistare spazi pubblicitari per campagne di marketing; e',
    s1_i2Bold: 'Fornitori di Spazi',
    s1_i2Rest: ', che possiedono, gestiscono o controllano spazi pubblicitari fisici, inclusi ma non limitati a cartelloni, insegne esterne, schermi digitali e altri supporti mediatica.',
    s2: 'Requisiti',
    s2_p1: 'Gli utenti devono:',
    s2_i1: 'Avere almeno 18 anni;',
    s2_i2: 'Avere la capacità giuridica di concludere accordi vincolanti;',
    s2_i3: 'Fornire informazioni accurate e complete durante la registrazione;',
    s2_i4: 'Rispettare tutte le leggi e i regolamenti applicabili.',
    s2_p2: 'Gli utenti aziendali dichiarano di essere autorizzati a vincolare la propria azienda o organizzazione.',
    s3: 'Ruoli degli Utenti',
    s3_1: '3.1 Inserzionisti',
    s3_1_p1: 'Gli Inserzionisti possono:',
    s3_1_i1: 'Cercare, selezionare e acquistare spazi pubblicitari;',
    s3_1_i2: 'Caricare materiali pubblicitari;',
    s3_1_i3: 'Lanciare e gestire campagne.',
    s3_1_p2: 'Gli Inserzionisti sono i soli responsabili di:',
    s3_1_i4: 'La legalità dei loro contenuti pubblicitari;',
    s3_1_i5: 'La titolarità o autorizzazione di tutta la proprietà intellettuale utilizzata;',
    s3_1_i6: 'Il rispetto delle leggi sulla pubblicità.',
    s3_2: '3.2 Fornitori di Spazi',
    s3_2_p1: 'I Fornitori di Spazi possono:',
    s3_2_i1: 'Elencare gli spazi pubblicitari disponibili;',
    s3_2_i2: 'Impostare prezzi, disponibilità delle campagne e requisiti operativi;',
    s3_2_i3: 'Accettare inserimenti di campagne.',
    s3_2_p2: 'I Fornitori di Spazi dichiarano e garantiscono che:',
    s3_2_i4: 'Possiedono o controllano legalmente lo spazio pubblicitario;',
    s3_2_i5: 'Dispongono di tutti i permessi, licenze e diritti necessari per l\'uso pubblicitario commerciale;',
    s3_2_i6: 'Possono eseguire le campagne prenotate entro i tempi concordati.',
    s3_3: '3.3 Dichiarazione Legale per l\'Inserzione di Spazi Pubblicitari',
    s3_3_p1: 'Quando si elenca uno spazio pubblicitario esterno sulla Piattaforma, ogni Fornitore di Spazi deve confermare espressamente, al momento della presentazione, che:',
    s3_3_i1: 'Detiene i diritti legali sullo spazio pubblicitario presentato;',
    s3_3_i2: 'È autorizzato a offrirlo per uso commerciale;',
    s3_3_i3: 'L\'inserzione è conforme a tutte le leggi, permessi, licenze, regolamenti di zonizzazione e requisiti delle autorità locali applicabili.',
    s3_3_p2: 'Questa dichiarazione è condizione per l\'inserzione. Le presentazioni prive di questa conferma non saranno accettate. La Piattaforma si riserva il diritto di rimuovere qualsiasi inserzione in cui la dichiarazione risulti falsa o fuorviante, e di sospendere o chiudere l\'account di qualsiasi Fornitore di Spazi che fornisca informazioni inesatte.',
    s4: 'Ruolo della Piattaforma',
    s4_p1: 'La Piattaforma agisce esclusivamente come intermediario e facilitatore. La Società:',
    s4_i1: 'Non possiede spazi pubblicitari;',
    s4_i2: 'Non agisce come inserzionista o fornitore di spazi;',
    s4_i3: 'Non garantisce le performance delle campagne, le impressioni o i risultati commerciali;',
    s4_i4: 'Non è responsabile dell\'installazione o rimozione fisica degli annunci.',
    s4_p2: 'Ogni transazione stabilisce una relazione contrattuale diretta tra l\'Inserzionista e il Fornitore di Spazi.',
    s5: 'Prenotazioni di Campagna',
    s5_p1: 'Una prenotazione di campagna diventa vincolante una volta che:',
    s5_i1: 'L\'Inserzionista ha completato il pagamento - pagando per intero o, per una campagna pagata a rate, autorizzando il primo pagamento e l\'addebito diretto delle rate successive;',
    s5_i2: 'Ogni spazio pubblicitario è confermato - immediatamente per gli spazi a prenotazione immediata, oppure dal relativo Fornitore di Spazi entro il periodo di conferma;',
    s5_i3: 'La data di inizio della campagna è programmata.',
    s5_p2: 'Tutte le prenotazioni sono soggette al periodo minimo di preavviso operativo specificato dal Fornitore di Spazi. Il periodo minimo di preavviso determina il momento più tardivo in cui un Inserzionista può presentare e pagare una campagna. Il mancato rispetto può comportare rifiuto o riprogrammazione.',
    s6: 'Condizioni di Pagamento',
    s6_1: '6.1 Pagamenti degli Inserzionisti',
    s6_1_p1: 'Gli Inserzionisti pagano secondo il piano di pagamento scelto al checkout:',
    s6_1_i1: 'Pagamento per intero - l\'importo totale della campagna viene addebitato al checkout;',
    s6_1_i2: 'Mensile o ogni tre mesi - i costi di produzione e il primo periodo di fatturazione vengono addebitati al checkout, e ogni periodo di fatturazione successivo viene incassato tramite addebito diretto il primo giorno. Questi piani sono disponibili solo quando la campagna si estende oltre il suo primo periodo di fatturazione.',
    s6_1_p2: 'Il checkout deve essere completato prima della data di inizio della campagna e prima della scadenza del periodo di preavviso minimo del Fornitore di Spazi. Quando gli spazi pubblicitari richiedono una conferma, il pagamento viene solo autorizzato al checkout e addebitato una volta confermati, e unicamente per gli spazi confermati. Il ritardato pagamento di qualsiasi rata è disciplinato dalla sezione 6.4. Se il checkout non viene completato in tempo:',
    s6_1_i3: 'La prenotazione può essere annullata automaticamente;',
    s6_1_i4: 'Il Fornitore di Spazi non ha l\'obbligo di riservare lo spazio pubblicitario.',
    s6_2: '6.2 Commissioni della Piattaforma',
    s6_2_p1: 'La Piattaforma può addebitare commissioni di servizio, provvigioni o commissioni di transazione. Tali commissioni saranno comunicate prima dell\'acquisto. Le commissioni della Piattaforma non sono rimborsabili salvo obbligo di legge.',
    s6_3: '6.3 Pagamenti ai Fornitori di Spazi',
    s6_3_p1: 'I Fornitori di Spazi diventano idonei al pagamento solo dopo che:',
    s6_3_i1: 'I materiali pubblicitari sono stati completamente installati;',
    s6_3_i2: 'La prova dell\'installazione è stata caricata tramite la Piattaforma;',
    s6_3_i3: 'Tale prova è approvata o non contestata entro il periodo di revisione applicabile.',
    s6_3_p2: 'La prova deve includere evidenza fotografica chiara che mostri la campagna correttamente esposta. La Piattaforma si riserva il diritto di verificare l\'autenticità. I pagamenti possono essere ritardati, trattenuti o annullati in caso di frode, controversia o inadempimento.',
    s6_4: '6.4 Obblighi di Pagamento e Ritardato Pagamento',
    s6_4_p1: 'Ogni prenotazione confermata costituisce un obbligo di pagamento vincolante dell\'Inserzionista. L\'Inserzionista è tenuto a corrispondere, integralmente e alle rispettive scadenze, tutti gli importi relativi alle campagne e agli spazi pubblicitari prenotati, compresa ogni rata di una campagna pagata a rate (mensilmente o ogni tre mesi).',
    s6_4_i1: 'Qualsiasi importo non pagato entro la scadenza - compreso un addebito diretto respinto, restituito o stornato - si considera scaduto da tale data. La Piattaforma ne darà comunicazione all\'Inserzionista e potrà tentare nuovamente l\'incasso.',
    s6_4_i2: 'Qualora un importo relativo a una campagna resti insoluto per oltre due (2) mesi dalla scadenza, il Fornitore di Spazi può, senza alcuna responsabilità nei confronti dell\'Inserzionista, rimuovere le creatività dell\'Inserzionista dagli spazi pubblicitari interessati e rendere tali spazi disponibili ad altri inserzionisti.',
    s6_4_i3: 'Tale rimozione non libera l\'Inserzionista dai propri obblighi: tutti gli importi già scaduti, unitamente alle eventuali commissioni applicabili ai sensi della sezione 9.3, restano integralmente dovuti.',
    s6_4_i4: 'La Piattaforma e/o il Fornitore di Spazi possono agire in giudizio per il recupero degli importi insoluti, maggiorati degli interessi di mora al tasso legale applicabile e delle ragionevoli spese di recupero e legali, nei limiti consentiti dalla legge applicabile.',
    s6_4_i5: 'La Piattaforma può inoltre sospendere l\'account dell\'Inserzionista e rifiutare nuove prenotazioni fino al saldo di tutti gli importi scaduti, ai sensi della sezione 15.',
    s6_4_p2: 'La rimozione delle creatività ai sensi della presente sezione non costituisce inadempimento del Fornitore di Spazi ai sensi delle sezioni 9.4 e 9.5 e non dà diritto ad alcun rimborso.',
    s7: 'Materiali di Campagna',
    s7_p1: 'Gli Inserzionisti devono presentare i materiali della campagna entro la scadenza richiesta. I materiali devono:',
    s7_i1: 'Soddisfare le specifiche tecniche;',
    s7_i2: 'Essere stampabili e utilizzabili;',
    s7_i3: 'Essere conformi alle leggi applicabili;',
    s7_i4: 'Non contenere contenuti illegali, diffamatori, offensivi o che violino diritti altrui.',
    s7_p2: 'I Fornitori di Spazi possono rifiutare materiali non conformi. La Piattaforma può rimuovere contenuti a sua esclusiva discrezione.',
    s8: 'Prova di Installazione',
    s8_p1: 'I Fornitori di Spazi devono caricare la prova di installazione tempestivamente. Il mancato caricamento può comportare:',
    s8_i1: 'Ritardo nel pagamento;',
    s8_i2: 'Annullamento del pagamento;',
    s8_i3: 'Sospensione dalla Piattaforma.',
    s8_p2: 'Gli Inserzionisti possono contestare la prova entro il periodo di contestazione applicabile dopo il caricamento. In assenza di contestazione entro tale periodo, la prova si considera accettata.',
    s9: 'Cancellazioni e Rimborsi',
    s9_1: '9.1 Cancellazione da parte dell\'Inserzionista',
    s9_1_p1: 'Se un Inserzionista cancella:',
    s9_1_i1: 'Prima del periodo minimo di preavviso del Fornitore di Spazi: ammissibile al rimborso, meno le commissioni applicabili;',
    s9_1_i2: 'Dopo l\'inizio del periodo di preavviso: il rimborso può essere negato.',
    s9_1_p2: 'I costi di produzione, stampa e preparazione possono non essere rimborsabili.',
    s9_2: '9.2 Cancellazione da parte del Fornitore di Spazi',
    s9_2_p1: 'Se un Fornitore di Spazi cancella una prenotazione confermata senza valido motivo:',
    s9_2_i1: 'L\'Inserzionista riceverà un rimborso completo;',
    s9_2_i2: 'Il Fornitore di Spazi potrà subire penali, riduzione della visibilità, sospensione o chiusura dell\'account.',
    s9_3: '9.3 Politica di cancellazione della campagna',
    s9_3_i1: 'Le campagne in stato In attesa possono essere cancellate gratuitamente in qualsiasi momento prima del pagamento.',
    s9_3_i5: 'Qualora la data di cancellazione preceda la data di inizio di ciascuna attivazione outdoor di un numero di giorni superiore al periodo di preavviso minimo del rispettivo Fornitore di Spazi, non si applica alcuna commissione di cancellazione e l\'Inserzionista riceve il rimborso integrale di tutti gli importi versati.',
    s9_3_i2: 'Una volta effettuato il pagamento, si applica una commissione di cancellazione del 30% del valore totale della campagna qualora una o più attivazioni outdoor della campagna rientrino nel periodo di preavviso minimo richiesto dal rispettivo Fornitore di Spazi.',
    s9_3_i3: 'Per le aziende registrate in Portogallo, l\'aliquota IVA applicabile sarà applicata alla commissione di cancellazione.',
    s9_3_i4: 'Qualora una o più attivazioni outdoor rientrino nel periodo di preavviso minimo richiesto dal Fornitore di Spazi, i costi di allestimento e stampa non sono rimborsabili.',
    s9_3_i6: 'La cancellazione di una campagna già in corso comporta la perdita del 100% del valore della campagna. Non verrà emesso alcun rimborso.',
    s9_3_i7: 'Qualora si applichi la commissione di cancellazione del 30%, il 20% del valore totale della campagna sarà trasferito ai rispettivi fornitori di spazi, al netto della commissione standard del 5% della piattaforma e dell\'IVA applicabile.',
    s9_4: '9.4 Rimborso per placement non comprovati',
    s9_4_p1: 'Nel caso in cui un Fornitore di Spazi non presenti prova valida di affissione per uno o più spazi pubblicitari entro il termine richiesto, Scapow emetterà un rimborso all\'Inserzionista come segue:',
    s9_4_i1: "Per ogni giorno del periodo della campagna in cui uno spazio pubblicitario non espone il creativo dell'Inserzionista, verrà rimborsato all'Inserzionista il valore giornaliero proporzionale di tale spazio.",
    s9_4_i4: "Sarà applicata una commissione di cancellazione del 10% sull'importo totale rimborsato per i giorni non conformi, oltre all'IVA applicabile.",
    s9_4_i2: 'I rimborsi verranno elaborati entro un termine ragionevole dalla conferma che la prova di affissione non è stata fornita o è stata ritenuta non valida.',
    s9_4_i3: 'Le commissioni di servizio della piattaforma applicabili ai placement comprovati e completati rimangono non rimborsabili.',
    s9_5: '9.5 Inadempimento del Fornitore di Spazi - Esecuzione Parziale della Campagna',
    s9_5_p1: 'Qualora un Fornitore di Spazi non esponga i materiali pubblicitari dell\'Inserzionista per l\'intera durata concordata del periodo di campagna, ciascun giorno in cui l\'obbligo di esposizione concordato non viene rispettato costituirà un "Giorno di Inadempimento".',
    s9_5_a: 'a) Responsabilità Finanziaria nei confronti di Scapow',
    s9_5_p2: 'In relazione a ciascun Giorno di Inadempimento, il Fornitore di Spazi sarà responsabile nei confronti della Piattaforma per un importo equivalente alla tariffa giornaliera di valore pubblicitario applicabile allo spazio campagna rilevante (l\'"Importo di Inadempimento"). Il recupero dell\'Importo di Inadempimento verrà effettuato a esclusiva discrezione della Piattaforma mediante uno o più dei seguenti mezzi:',
    s9_5_i1: '(i) richiedendo al Fornitore di Spazi di versare l\'Importo di Inadempimento direttamente alla Piattaforma entro il termine specificato in un avviso scritto emesso dalla Piattaforma; o',
    s9_5_i2: '(ii) deducendo l\'Importo di Inadempimento da qualsiasi pagamento di campagna attuale o futuro dovuto al Fornitore di Spazi, sia nell\'ambito della stessa campagna che di qualsiasi successivo rapporto sulla Piattaforma.',
    s9_5_p3: 'La Piattaforma si riserva il diritto di applicare entrambi i rimedi contemporaneamente nella misura necessaria per recuperare l\'intero Importo di Inadempimento totale.',
    s9_5_b: 'b) Piena Restituzione all\'Inserzionista',
    s9_5_p4: 'In relazione a ciascun Giorno di Inadempimento, l\'Inserzionista avrà diritto al rimborso integrale di tutti gli importi versati per tali giorni, inclusa la corrispondente tariffa giornaliera di campagna, le eventuali commissioni applicabili della Piattaforma e le eventuali spese di servizio o transazione attribuibili a quei giorni. Tale rimborso sarà elaborato dalla Piattaforma entro un periodo ragionevole a seguito della conferma dell\'inadempimento.',
    s9_5_c: 'c) Determinazione dell\'Inadempimento',
    s9_5_p5: 'Il mancato rispetto del periodo di esposizione concordato sarà valutato sulla base delle prove presentate tramite la Piattaforma, inclusi, a titolo esemplificativo e non esaustivo, i registri di prova di esposizione, i rapporti degli Inserzionisti, la documentazione fotografica e qualsiasi altro materiale ritenuto pertinente dalla Piattaforma. La determinazione della Piattaforma sarà definitiva e vincolante ai fini del calcolo dell\'Importo di Inadempimento e della gestione dei rimborsi agli Inserzionisti, senza pregiudizio dei diritti legali di entrambe le parti ai sensi della legge applicabile.',
    s9_6: '9.6 Forza Maggiore - Calamità Naturali',
    s9_6_p1: 'Un "Evento di Forza Maggiore" è una calamità naturale o un\'emergenza connessa, al di fuori del ragionevole controllo dell\'Inserzionista e del Fornitore di Spazi, che impedisce materialmente a uno spazio pubblicitario di esporre la creatività dell\'Inserzionista, o rende tale esposizione non sicura - inclusi terremoti, alluvioni, tempeste, uragani, incendi boschivi, frane, ordini di evacuazione o di emergenza emessi dalle autorità competenti e interruzioni di corrente causate da tali eventi. Il maltempo ordinario, la normale usura e la mancanza di manutenzione non costituiscono Eventi di Forza Maggiore.',
    s9_6_a: 'a) Comunicazione e Prove',
    s9_6_p2: 'Il Fornitore di Spazi deve segnalare un Evento di Forza Maggiore tramite la Piattaforma entro 48 ore da quando ne viene a conoscenza, insieme a prove (come fotografie o allerte ufficiali) e a una data stimata di ripristino. La Piattaforma valuterà, sulla base di tali prove, se l\'evento è ammissibile; la sua decisione sarà definitiva e vincolante ai fini della presente sezione.',
    s9_6_b: 'b) Effetti per il Fornitore di Spazi',
    s9_6_i1: 'Ogni giorno in cui l\'esposizione è impedita da un Evento di Forza Maggiore ammissibile (un "Giorno di Forza Maggiore") non costituisce un Giorno di Inadempimento ai sensi della sezione 9.5, e non è dovuto alcun Importo per Inadempimento in relazione allo stesso.',
    s9_6_i2: 'Nessun pagamento è dovuto al Fornitore di Spazi per i Giorni di Forza Maggiore.',
    s9_6_i3: 'Il Fornitore di Spazi deve ripristinare l\'esposizione entro 5 giorni lavorativi dalla fine dell\'Evento di Forza Maggiore. Ogni giorno successivo a tale termine in cui l\'esposizione non sia stata ripristinata costituisce un Giorno di Inadempimento ai sensi della sezione 9.5.',
    s9_6_i4: 'Il Fornitore di Spazi resta responsabile della manutenzione e di un\'adeguata assicurazione delle proprie strutture, compreso il costo di ristampa e reinstallazione di qualsiasi materiale creativo danneggiato o distrutto dall\'evento.',
    s9_6_c: 'c) Effetti per l\'Inserzionista',
    s9_6_i5: 'L\'Inserzionista ha diritto al rimborso integrale di tutti gli importi pagati per i Giorni di Forza Maggiore, compresi la tariffa giornaliera della campagna, la relativa commissione della Piattaforma e l\'IVA applicabile, senza la commissione del 10% di cui alla sezione 9.4.',
    s9_6_i6: 'In alternativa, l\'Inserzionista può scegliere di spostare i giorni interessati alla fine della campagna, compatibilmente con la disponibilità dello spazio pubblicitario.',
    s9_6_i7: 'Qualora uno spazio pubblicitario diventi indisponibile a causa di un Evento di Forza Maggiore prima dell\'inizio della sua attivazione, l\'Inserzionista o il Fornitore di Spazi possono rimuoverlo dalla campagna senza alcuna commissione di cancellazione, in deroga alla sezione 9.3, e l\'Inserzionista riceve il rimborso integrale degli importi pagati per lo stesso.',
    s9_6_i8: 'Qualora un Evento di Forza Maggiore duri più di 14 giorni, o più della metà del periodo residuo della campagna sullo spazio interessato, l\'Inserzionista può annullare la parte restante di tale spazio senza costi e ricevere il rimborso dei giorni residui.',
    s9_6_i9: 'Per le campagne pagate a rate mensili, le rate future saranno ridotte o annullate di conseguenza.',
    s9_6_d: 'd) Ambito',
    s9_6_p3: 'Gli eventi che interessano soltanto l\'attività dell\'Inserzionista, e non gli spazi pubblicitari, non rientrano in questa sezione; si applica la Politica di Cancellazione delle Campagne di cui alla sezione 9.3.',
    s9_7: '9.7 Vandalismo',
    s9_7_p1: 'Per "Vandalismo" si intende il danneggiamento, l\'imbrattamento o la rimozione deliberati di uno spazio pubblicitario o della creatività dell\'Inserzionista da parte di terzi estranei all\'Inserzionista e al Fornitore di Spazi - ad esempio graffiti, manifesti strappati o coperti, oppure schermi o strutture danneggiati.',
    s9_7_i1: 'Il Fornitore di Spazi deve segnalare il Vandalismo tramite la Piattaforma entro 48 ore da quando ne viene a conoscenza, insieme a fotografie e, ove disponibile, a una denuncia alle autorità.',
    s9_7_i2: 'Il Fornitore di Spazi deve ripristinare l\'esposizione entro 3 giorni lavorativi dalla segnalazione, a proprie spese, compresa la ristampa e la reinstallazione della creatività.',
    s9_7_i3: 'I giorni in cui l\'esposizione è impedita entro tale termine di ripristino sono trattati come Giorni di Forza Maggiore ai sensi della sezione 9.6: l\'Inserzionista ha diritto al loro rimborso integrale, senza commissioni, e non è dovuto alcun Importo per Inadempimento.',
    s9_7_i4: 'I giorni successivi al termine di ripristino, o il Vandalismo derivante dalla mancata adozione di ragionevoli misure preventive da parte del Fornitore di Spazi, costituiscono Giorni di Inadempimento ai sensi della sezione 9.5.',
    s9_7_i5: 'Qualora lo stesso spazio pubblicitario sia vandalizzato tre o più volte entro 30 giorni, il Fornitore di Spazi deve adottare ragionevoli misure preventive, e l\'Inserzionista può annullare la parte restante di tale spazio senza costi e ricevere il rimborso dei giorni residui.',
    s9_7_p2: 'La segnalazione di un Evento di Forza Maggiore o di un Vandalismo non avvenuto sarà considerata come presentazione di una falsa prova di esposizione ai sensi della sezione 12 e può comportare la sospensione o la chiusura immediata dell\'account.',
    proofProtectionNote: 'Il tuo investimento è protetto: se un placement outdoor non fornisce prova verificata di affissione, Scapow rimborserà l\'importo corrispondente per quel placement.',
    s10: 'Controversie',
    s10_p1: 'Gli utenti concordano di tentare prima la risoluzione tramite la Piattaforma. La Piattaforma può:',
    s10_i1: 'Esaminare le prove della campagna;',
    s10_i2: 'Richiedere documentazione aggiuntiva;',
    s10_i3: 'Emettere una decisione non vincolante.',
    s10_p2: 'La decisione della Piattaforma non sostituisce i diritti legali ai sensi della legge applicabile.',
    s11: 'Proprietà Intellettuale',
    s11_p1: 'Gli Inserzionisti mantengono la proprietà dei contenuti presentati.',
    s11_p2: 'Caricando i materiali, gli Inserzionisti concedono alla Piattaforma e ai Fornitori di Spazi una licenza limitata e non esclusiva per utilizzare, riprodurre e visualizzare tali materiali esclusivamente per l\'esecuzione della campagna.',
    s11_p3: 'I Fornitori di Spazi mantengono la proprietà delle loro inserzioni, immagini e dati di localizzazione.',
    s11_p4: 'La Piattaforma mantiene la proprietà di tutto il software, del marchio e dei sistemi della piattaforma.',
    s12: 'Usi Vietati',
    s12_p1: 'Gli utenti non possono:',
    s12_i1: 'Commettere frodi;',
    s12_i2: 'Caricare contenuti fuorvianti o illegali;',
    s12_i3: 'Eludere i pagamenti;',
    s12_i4: 'Contattare utenti al di fuori della Piattaforma per evitare commissioni;',
    s12_i5: 'Manipolare recensioni o risultati delle campagne;',
    s12_i6: 'Caricare false prove di installazione.',
    s12_p2: 'La violazione può comportare sospensione o chiusura immediata.',
    s13: 'Responsabilità',
    s13_p1: 'Nella misura massima consentita dalla legge, la Piattaforma non sarà responsabile per:',
    s13_i1: 'Prestazioni inferiori alle aspettative della campagna;',
    s13_i2: 'Danni meteorologici, calamità naturali e vandalismo, disciplinati dalle sezioni 9.6 e 9.7;',
    s13_i3: 'Ritardi causati da terzi;',
    s13_i4: 'Difetti di stampa non causati dalla Piattaforma;',
    s13_i5: 'Atti od omissioni degli utenti.',
    s13_p2: 'La responsabilità totale non supererà le commissioni totali pagate alla Piattaforma per la campagna in questione.',
    s14: 'Manleva',
    s14_p1: 'Gli utenti si impegnano a manlevare e tenere indenne la Società da qualsiasi reclamo, perdita, danno, responsabilità o spesa derivante da:',
    s14_i1: 'Violazione dei presenti Termini;',
    s14_i2: 'Contenuti pubblicitari illegali;',
    s14_i3: 'Violazione dei diritti di terzi;',
    s14_i4: 'Condotta fraudolenta.',
    s15: 'Sospensione dell\'Account',
    s15_p1: 'La Piattaforma può sospendere o chiudere account per:',
    s15_i1: 'Frode;',
    s15_i2: 'Mancato pagamento;',
    s15_i3: 'Controversie ripetute;',
    s15_i4: 'Abuso della Piattaforma;',
    s15_i5: 'Violazione dei presenti Termini.',
    s16: 'Imposte',
    s16_p1: 'Gli utenti sono responsabili delle proprie imposte, incluse IVA, imposta sulle vendite, imposta sul reddito e qualsiasi altra tassa applicabile. La Piattaforma può riscuotere imposte ove legalmente richiesto.',
    s17: 'Protezione dei Dati',
    s17_p1: 'I dati degli utenti saranno trattati in conformità con la Politica sulla Privacy della Piattaforma e le leggi applicabili sulla protezione dei dati. Gli utenti sono responsabili di garantire di avere diritti legali su qualsiasi dato personale caricato.',
    s18: 'Legge Applicabile',
    s18_p1: 'I presenti Termini saranno disciplinati dalle leggi applicabili senza riguardo ai principi di conflitto di leggi. Le controversie saranno soggette alla giurisdizione esclusiva dei tribunali competenti.',
    s19: 'Modifiche',
    s19_p1: 'La Piattaforma può modificare i presenti Termini in qualsiasi momento. Il continuo utilizzo della Piattaforma dopo le modifiche costituisce accettazione.',
    s20: 'Contatto',
    s20_p1: 'Per richieste legali:',
  },
  team: {
    title: 'Gestione del Team',
    subtitle: 'Gestisci i membri del team e invia inviti',
    tabUsers: 'Membri Attivi',
    tabInvitations: 'Inviti',
    noUsers: 'Nessun membro attivo ancora',
    noUsersDesc: "Gli utenti appariranno qui una volta accettato l'invito",
    statusVerified: 'Verificato',
    statusPending: 'In attesa',
  },
  footer: {
    tagline:
      "Il mercato che connette i proprietari di spazi pubblicitari esterni con gli inserzionisti. Semplice, efficiente, d'impatto.",
    platform: 'Piattaforma',
    browseOutdoors: 'Esplora Spazi Esterni',
    createAccount: 'Crea Account',
    logIn: 'Accedi',
    forBusinesses: 'Per le Aziende',
    registerBusiness: "Registra l'Azienda",
    listOutdoors: 'Pubblica i tuoi Spazi',
    runCampaigns: 'Lancia Campagne',
    about: 'Chi siamo',
    howItWorks: 'Come Funziona',
    mission: 'La Nostra Missione',
    contactUs: 'Contattaci',
    copyright: '© 2026 Scapow by Codify. Tutti i diritti riservati.',
    privacy: 'Privacy',
    terms: 'Termini',
  },
  language: {
    select: 'Lingua',
    en: 'English',
    pt: 'Português',
    es: 'Español',
    de: 'Deutsch',
    zh: '中文',
    ja: '日本語',
    fr: 'Français',
    it: 'Italiano',
  },
  verification: {
    title: 'Verifica degli spazi di campagna',
    subtitle: 'Invia foto di prova per i tuoi spazi di campagna attivi in attesa di verifica. Tutti gli spazi di una campagna devono avere la prova inviata prima che il pagamento della campagna venga sbloccato.',
    empty: 'Nessuna verifica in sospeso',
    emptyDesc: 'Tutti i tuoi spazi di campagna attivi sono aggiornati. Torna a controllare una volta avviate le tue campagne.',
    uploadProof: 'Carica foto di prova',
    uploaded: 'Prova inviata',
    uploadSuccess: 'Foto di prova inviata con successo.',
    noName: 'Spazio di campagna',
    locating: 'Localizzazione…',
    awaitingVerification: 'In attesa di verifica',
    verified: 'Verificato',
    partiallyVerified: 'Parzialmente verificato',
    backToCampaigns: 'Torna alle campagne',
    noOutdoors: 'Nessuno spazio trovato per questa campagna',
    pendingCount: '{{count}} in sospeso',
    notYetAvailable: 'Verifica disponibile dal {{date}}',
    viewProof: 'Visualizza foto di prova',
    proofAlt: 'Foto di prova',
    deleteProof: 'Elimina prova',
    deleteProofSuccess: 'Foto di prova eliminata.',
    deleteProofConfirm: 'Sei sicuro di voler eliminare questa foto di prova? Questa azione non può essere annullata.',
  },
  howItWorksPage: {
    title: 'Come Funziona',
    subtitle: "Che tu possieda spazi pubblicitari o voglia raggiungere nuovi pubblici, Scapow lo rende semplice.",
    advertiserTab: 'Per gli Inserzionisti',
    ppTab: 'Per i Fornitori di Spazi',
    advertiserTitle: 'Raggiungi il Tuo Pubblico su Larga Scala',
    advertiserSubtitle: "Pianifica, lancia e monitora campagne pubblicitarie outdoor - tutto da un'unica piattaforma intuitiva.",
    adStep1Title: 'Scopri gli Spazi Giusti',
    adStep1Desc: 'Sfoglia migliaia di ubicazioni outdoor verificate su una mappa interattiva. Filtra per città, formato, dimensioni, disponibilità e tariffa giornaliera per trovare i luoghi perfetti per la tua campagna.',
    adStep2Title: 'Costruisci la Tua Campagna',
    adStep2Desc: "Seleziona più cartelloni e raggruppali in un'unica campagna. Imposta le date, carica le creatività e conferma il piano - senza bisogno di un'agenzia.",
    adStep3Title: 'Paga in Tutta Sicurezza',
    adStep3Desc: 'Ricevi un riepilogo di pagamento trasparente prima di confermare. Paga in tutta sicurezza tramite la nostra piattaforma e un gateway di pagamento sicuro, e ottieni una fattura ufficiale - tutto documentato e tracciabile.',
    adStep4Title: 'Monitora Ogni Affissione',
    adStep4Desc: 'Una volta attiva la campagna, i fornitori di spazi inviano una prova fotografica del cartellone. Monitora lo stato e le conferme direttamente dal tuo pannello di controllo.',
    ppTitle: 'Trasforma i Tuoi Spazi in Entrate',
    ppSubtitle: 'Pubblica una volta, raggiungi migliaia di inserzionisti e guadagna secondo i tuoi tempi.',
    ppStep1Title: 'Pubblica i Tuoi Spazi',
    ppStep1Desc: 'Crea annunci dettagliati per ciascuno dei tuoi spazi outdoor. Aggiungi dimensioni, foto, prezzi e disponibilità. Più completo è il tuo annuncio, più campagne attirerai.',
    ppStep2Title: 'Connettiti con le Campagne',
    ppStep2Desc: 'I tuoi spazi appaiono automaticamente nelle ricerche degli inserzionisti. Quando vieni selezionato per una campagna, ricevi una notifica e una prenotazione confermata - senza trattative.',
    ppStep3Title: 'Carica la Prova di Esposizione',
    ppStep3Desc: 'Una volta che il tuo spazio mostra la campagna, carica una prova fotografica tramite la piattaforma. Questa è la tua conferma di consegna - e avvia il processo di pagamento.',
    ppStep4Title: 'Ricevi il Pagamento',
    ppStep4Desc: "Una volta che la prova di esposizione è stata inviata per ogni spazio di una campagna, il pagamento viene rilasciato secondo i termini concordati. Tutti i vostri slot della campagna devono essere verificati prima che i fondi vengano elaborati - garantendo la consegna completa prima del pagamento.",
    ctaTitle: 'Pronto a iniziare?',
    ctaSubtitle: 'Unisciti a migliaia di aziende che stanno già crescendo con Scapow.',
    ctaAdvertiser: 'Inizia a Fare Pubblicità',
    ctaProvider: 'Pubblica i Miei Spazi',
  },
  brand: {
    slogan: "it's ooh good!",
  },
  missionPage: {
    title: 'La Nostra Missione',
    subtitle: 'Connettere il mercato della pubblicità esterna - affinché ogni spazio crei impatto e ogni campagna trovi il suo pubblico.',
    coreTitle: 'Cosa Ci Muove',
    coreDesc: "L'industria della pubblicità esterna è frammentata. Grandi spazi restano senza prenotazioni. Le campagne non raggiungono il loro potenziale. Crediamo che la tecnologia possa cambiare tutto questo - e Scapow è il modo.",
    pillar1Title: 'Amplificare Portata e Impatto',
    pillar1Desc: "Consentiamo agli inserzionisti di pianificare ed eseguire campagne outdoor ad alto impatto su più ubicazioni da un'unica piattaforma unificata - raggiungendo il pubblico su larga scala senza il peso operativo.",
    pillar2Title: 'Massimizzare i Ricavi dei Fornitori',
    pillar2Desc: 'Offriamo ai fornitori di spazi accesso diretto a un pool qualificato di domanda pubblicitaria, riducendo l\'inventario vacante e garantendo che i loro spazi generino entrate costanti e prevedibili.',
    pillar3Title: 'Connettere il Mercato OOH Statico',
    pillar3Desc: "Stiamo costruendo l'infrastruttura di cui l'industria outdoor aveva bisogno da tempo - un marketplace trasparente e digital-first dove l'offerta incontra la domanda in modo efficiente, equo e su larga scala.",
    pillar4Title: 'Fiducia Attraverso la Trasparenza',
    pillar4Desc: 'Dalla verifica delle credenziali aziendali alla prova fotografica di esposizione, ogni fase del processo Scapow è progettata per essere verificabile, responsabile e basata sulla fiducia reciproca tra tutte le parti.',
    visionTitle: 'La Nostra Visione',
    visionDesc: "Un mondo in cui ogni spazio outdoor è un'opportunità - e ogni brand può trovare la sua tela perfetta, ovunque il suo pubblico viva, lavori e si muova.",
    closingTitle: "Costruire il Futuro dell'OOH",
    closingDesc: "Scapow è più di un marketplace. È il tessuto connettivo dell'industria della pubblicità esterna - che riunisce fornitori di spazi, inserzionisti e la tecnologia che alimenta il loro successo condiviso.",
  },
  contact: {
    label: 'Mettiti in Contatto',
    title: 'Contattaci',
    subtitle: 'Hai una domanda, un feedback o vuoi semplicemente salutarci? Siamo felici di sentirti.',
    infoTitle: 'Parliamo',
    infoDesc: 'Che tu abbia curiosità su funzionalità, prezzi o altro - il nostro team è pronto a rispondere a tutte le tue domande.',
    responseTimeTitle: 'Risposta Rapida',
    responseTimeDesc: 'Di solito rispondiamo entro 24 ore.',
    emailTitle: 'Scrivici',
    whatsappTitle: 'WhatsApp',
    formTitle: 'Inviaci un messaggio',
    fieldName: 'Il tuo Nome',
    fieldEmail: 'La tua Email',
    fieldSubject: 'Oggetto',
    fieldMessage: 'Messaggio',
    namePlaceholder: 'Mario Rossi',
    emailPlaceholder: 'tu@esempio.it',
    subjectPlaceholder: 'Come possiamo aiutarti?',
    messagePlaceholder: 'Dicci cosa hai in mente…',
    submit: 'Invia Messaggio',
    submitting: 'Invio in corso…',
    successTitle: 'Messaggio inviato!',
    successDesc: 'Grazie per averci contattato. Ti risponderemo a breve.',
    backHome: 'Torna alla Home',
    errorRequired: 'Questo campo è obbligatorio.',
    errorEmail: 'Inserisci un indirizzo email valido.',
  },
  calendar: {
    calendarMonthsHint: 'Si prenota per mesi di calendario interi, dal giorno 1 all’ultimo. Fai clic su un giorno 1 per iniziare, su un giorno successivo per aggiungere il suo mese o all’interno della prenotazione per accorciarla.',
    startOnMonthFirstHint: 'Le prenotazioni iniziano il primo giorno di un mese.',
    fullMonthHint: 'Prenotazione a mesi: scegli il giorno di inizio, poi fai clic su un giorno successivo per aggiungere mesi; ognuno termina lo stesso giorno del mese seguente (iniziando il giorno 1, l’ultimo giorno del mese). Fai clic all’interno della prenotazione per accorciarla.',
    discountsTitle: 'Prenota più a lungo, risparmia di più',
    discountTier: '{{days}}+ giorni',
    discountsPickStart: 'Scegli una data di inizio per vedere quali date di fine hanno uno sconto.',
    discountsHighlighted: 'Più il verde è scuro, maggiore è lo sconto - le etichette mostrano dove inizia ciascuno.',
    discountApplied: '{{percentage}}% di sconto su questi {{count}} giorni',
    discountNextTier: 'Aggiungi {{days}} giorno/i per risparmiare il {{percentage}}%',
    latestStartInfo: 'Date di inizio fino al {{date}}',
    blockedLegend: 'Bloccato / non disponibile',
    pendingLegend: 'In attesa (non ancora salvato)',
    loading: 'Caricamento disponibilità…',
    noticeRequired: 'Prima data disponibile: {{date}} (preavviso di {{count}} giorni richiesto)',
    minimumDaysError: 'Noleggio minimo {{count}} giorni - estendi la selezione',
    overlapError: 'Il periodo selezionato include date riservate - scegli solo giorni consecutivi disponibili',
  },
  approvals: {
    thisBookingLegend: 'Questa prenotazione',
    blockedSelection: 'Periodo bloccato:',
    blockedSelectionEmpty: 'Scegli le date di inizio e fine nel calendario.',
    title: 'Approvazioni',
    subtitle: 'Conferma se i tuoi spazi sono disponibili per queste campagne pagate.',
    emptyTitle: 'Sei in pari',
    emptyDesc: 'Quando un inserzionista prenota uno dei tuoi spazi, comparirà qui per l’approvazione.',
    campaignFallback: 'Campagna',
    outdoorsToReview: 'Spazi da esaminare: {{count}}',
    startsOn: 'Inizia il {{date}}',
    answerBy: 'Rispondi entro il {{date}}',
    review: 'Esamina',
    youEarn: 'Guadagni',
    backToList: 'Torna alle approvazioni',
    reviewEyebrow: 'Richiesta di approvazione',
    summaryLine: 'Spazi: {{count}} · Guadagni {{value}}',
    deadlineNotice: 'Rispondi entro il {{date}}. Gli spazi senza risposta in tempo vengono rimossi dalla campagna.',
    progress: '{{answered}} di {{total}} risposti',
    approveAll: 'Approva tutti',
    available: 'Disponibile',
    unavailable: 'Non disponibile',
    decisionFor: '{{name}} è disponibile?',
    decisionRequired: 'Scegli una risposta.',
    blockedHint: 'Indica quando questo spazio è già occupato: bloccheremo queste date.',
    blockedFrom: 'Bloccato dal',
    blockedTo: 'Bloccato fino al',
    blockedRequired: 'Entrambe le date sono obbligatorie.',
    blockedOrder: 'La data di fine deve essere uguale o successiva a quella di inizio.',
    viewCreative: 'Vedi la creatività di {{name}}',
    noCreative: 'Ancora nessuna creatività',
    feedbackMandatory: 'Serve una risposta per ogni spazio.',
    submit: 'Invia risposte',
    fixBeforeSubmit: 'Rispondi per ogni spazio e controlla le date bloccate.',
    confirmTitle: 'Inviare le risposte?',
    confirmSummary: 'Disponibili: {{approved}} · Non disponibili: {{unavailable}}',
    confirmNote: 'Le risposte non possono essere modificate dopo l’invio.',
    submitted: 'Grazie, le tue risposte sono state inviate.',
    submitError: 'Impossibile inviare le tue risposte.',
    allAnsweredTitle: 'Già risposto',
    allAnsweredDesc: 'Hai risposto per tutti i tuoi spazi di questa campagna.',
    loadErrorTitle: 'Questa approvazione non è disponibile',
    loadErrorDesc: 'Potrebbe essere già stata risposta, oppure la campagna è stata annullata.',
  },
  status: {
    installment: {
      SCHEDULED: 'Programmata',
      PROCESSING: 'In elaborazione',
      PAID: 'Pagata',
      FAILED: 'Non riuscita',
      CANCELLED: 'Annullata',
    },
    campaign: {
      PENDING: 'Bozza',
      AWAITING_PAYMENT: 'In attesa di pagamento',
      CONFIRMING: 'In attesa dei fornitori',
      AWAITING_CONFIRMATION: 'Decisione richiesta',
      READY: 'Confermata',
      RUNNING: 'In onda',
      COMPLETED: 'Completata',
      CANCELLED: 'Annullata',
      UNAVAILABLE: 'Non disponibile',
    },
    payment: {
      PENDING: 'Non pagato',
      VALIDATING_PAYMENT: 'Convalida del pagamento',
      MANUAL_VALIDATION: 'In revisione',
      TRANSFER_REQUESTED: 'Bonifico richiesto',
      PAID: 'Pagato',
      CANCELLED: 'Annullato',
      PARTIALLY_REFUNDED: 'Rimborsato in parte',
      FULLY_REFUNDED: 'Rimborsato',
      FAILED: 'Non riuscito',
    },
    campaignOutdoor: {
      PENDING: 'In attesa di prova',
      VERIFYING: 'Verifica della prova',
      FOR_MANUAL_APPROVAL: 'Prova in revisione',
      APPROVED: 'Prova approvata',
      REJECTED: 'Prova rifiutata',
      REFUNDED: 'Rimborsato',
      CANCELLED: 'Annullato',
    },
    proof: {
      PENDING: 'In attesa',
      VALID: 'Valida',
      MANUAL_VALIDATION: 'In revisione',
      INVALID: 'Non valida',
    },
    paymentType: {
      BUYING_ADS: 'Acquisto pubblicitario',
      SELLING_ADS: 'Pagamento al fornitore',
      REFUND_BUYING_PART: 'Rimborso all’inserzionista',
      REFUND_SELLING_PART: 'Rimborso del fornitore',
      PLACEMENT_PROVIDER_DEBT: 'Debito del fornitore',
      PLACEMENT_PROVIDER_CANCELLATION_FEE: 'Compensazione per annullamento',
    },
  },
  offlineCampaigns: {
    creativesTitle: 'Creatività',
    creativesSubtitle: 'Grafiche da installare. Va bene qualsiasi dimensione: decidi tu come si adattano a ogni spazio.',
    uploadCreatives: 'Carica creatività',
    noCreatives: 'Nessuna creatività. Fai clic per caricare file JPG, PNG, TIFF o PDF.',
    creativesUploaded: 'Creatività caricate.',
    creativeRemoved: 'Creatività rimossa.',
    removeCreative: 'Rimuovi creatività',
    removeCreativeConfirm: 'Rimuovere questa creatività? L’operazione non può essere annullata.',
    downloadOriginal: 'Scarica originale',
    filesTitle: 'File',
    filesSubtitle: 'Contratti, brief o qualsiasi altro file di questa campagna.',
    uploadFiles: 'Carica file',
    noFiles: 'Nessun file caricato.',
    filesUploaded: 'File caricati.',
    fileRemoved: 'File rimosso.',
    removeFile: 'Rimuovi file',
    removeFileConfirm: 'Rimuovere «{{name}}»? L’operazione non può essere annullata.',
    download: 'Scarica',
    remove: 'Rimuovi',
    outdoorsTitle: 'Spazi',
    noOutdoors: 'Questa campagna non ha ancora spazi.',
    modalTitle: 'Aggiungi a una campagna offline',
    newTitle: 'Nuova campagna offline',
    pickTitle: 'Scegli una campagna offline',
    datesTitle: 'Scegli le date',
    doneTitle: 'Spazio aggiunto',
    forOutdoor: 'Spazio:',
    optionNew: 'Nuova',
    optionNewDesc: 'Crea una campagna per una prenotazione venduta fuori da Scapow.',
    optionPick: 'Scegli esistente',
    optionPickDesc: 'Aggiungilo a una delle tue campagne offline.',
    name: 'Nome della campagna',
    nameRequired: 'Dai un nome alla campagna.',
    details: 'Dettagli',
    detailsHint: 'Ad es. il cliente o il canale di vendita.',
    notes: 'Note',
    notesHint: 'Note interne - visibili solo al tuo team.',
    instructions: 'Istruzioni',
    instructionsHint: 'Per chi installa la creatività.',
    createAndContinue: 'Crea e continua',
    createError: 'Impossibile creare la campagna offline.',
    addError: 'Impossibile aggiungere lo spazio alla campagna.',
    noneYet: 'Non hai ancora campagne offline.',
    outdoorsCount: 'Spazi: {{count}}',
    createdOn: 'creata il {{date}}',
    datesIntro: 'Scegli quando lo spazio è prenotato per «{{campaign}}». Le date già occupate sono mostrate e non selezionabili.',
    pickDates: 'Scegli le date di inizio e fine nel calendario.',
    addToCampaign: 'Aggiungi alla campagna',
    doneMessage: '{{outdoor}} è stato aggiunto a «{{campaign}}».',
    doneHint: 'Queste date sono ora bloccate per altre prenotazioni.',
    backToSearch: 'Torna alla ricerca',
    getAvailability: 'Verifica disponibilità',
    clearAvailability: 'Cancella disponibilità',
    availabilityTitle: 'Verifica disponibilità',
    availabilityHint: 'Scegli una data di inizio e di fine per vedere solo gli spazi liberi per l’intero periodo.',
    showAvailable: 'Mostra spazi disponibili',
    dimensionsLabel: 'Dimensioni',
    noMatches: 'Nessuno spazio corrisponde a questi filtri',
    noMatchesHint: 'Prova altre dimensioni o date, oppure cancella i filtri.',
    clearFilters: 'Cancella filtri',
    addButton: 'Aggiungi a campagna offline',
    addTooltip: 'Aggiungi a una campagna non prenotata tramite Scapow',
  },
};

export default it;
